/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SBE SMS API
 * SMS API. AccessTokenGuard 보호 라우트는 Authorization: Bearer <jwt> 가 필요.
 * OpenAPI spec version: 1.0
 */
import {
  HttpClient,
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import {
  Observable
} from 'rxjs';

import type {
  AddOrgMemberBodyDto,
  AddTeamMemberBodyDto,
  AssignOrgMemberLabelDto,
  BalanceResponseDto,
  BatchManagedUsersBodyDto,
  BatchManagedUsersResultDto,
  BatchOrgMembersBodyDto,
  BatchOrgMembersResultDto,
  BatchOrgTeamsBodyDto,
  BatchTeamMembersBodyDto,
  BatchUpdateOrgMemberLabelAssignmentsDto,
  CheckoutRequestDto,
  CheckoutResponseDto,
  ContinuityLinkDto,
  CreateContinuityLinkBodyDto,
  CreateManagedUserBodyDto,
  CreateMessageBodyDto,
  CreateOrgBodyDto,
  CreateOrgMemberLabelDto,
  CreateOrgTeamBodyDto,
  CreateOriginatorBodyDto,
  CreateStaffInvitationBodyDto,
  CreateTemplateBodyDto,
  CreateTwoFactorAuthChallengeBodyDto,
  CreatedManagedUserDto,
  CreatedMessageResponseDto,
  CreditOfferDto,
  CreditsHistoryControllerGetHistoryParams,
  CreditsHistoryResponseDto,
  CreditsOrdersControllerGetOrdersParams,
  CreditsOrdersResponseDto,
  DeleteOrgResultDto,
  DeliveryReportByTokenBodyDto,
  EstablishOrgGrantBodyDto,
  GrantOrgPermissionDto,
  GrantOrgPermissionToMemberDto,
  HealthResponseDto,
  InviteOrgMemberBodyDto,
  IssueMagicLinkEntryDto,
  IssuedSessionResponseDto,
  ListMessageDetailsResponseDto,
  ListMessagesResponseDto,
  ListMyOrgMembersResponseDto,
  ListNotificationsResponseDto,
  ListOrgAuditLogResponseDto,
  ListOrgInvitationsAdminResponseDto,
  ListOrgInvitationsResponseDto,
  ListOrgMemberBalancesResponseDto,
  ListOrgMembersResponseDto,
  ListOrgTeamsResponseDto,
  ListOrgsResponseDto,
  ListOriginatorDocumentsResponseDto,
  ListOriginatorsResponseDto,
  ListTeamAdminsResponseDto,
  ListTemplatesResponseDto,
  MagicLinkEntryResponseDto,
  MarkAllNotificationsReadResponseDto,
  MeResponseDto,
  MemberPickerExchangeResultDto,
  MemberPickerSessionCreatedDto,
  MessageDetailDto,
  MessagesControllerListDetailsParams,
  MessagesControllerListParams,
  MoveOrgTeamBodyDto,
  NiceInitBodyDto,
  NiceInitResponseDto,
  NiceVerifyBodyDto,
  NiceVerifyResponseDto,
  OrgAccessTokenBodyDto,
  OrgAccessTokenResponseDto,
  OrgCreditTransferBodyDto,
  OrgCreditTransferResultDto,
  OrgCreditsHistoryControllerGetHistoryParams,
  OrgCreditsOrdersControllerGetOrdersParams,
  OrgDocumentUploadUrlBodyDto,
  OrgDocumentUploadUrlResponseDto,
  OrgDto,
  OrgInvitationResponseDto,
  OrgInvitationSentDto,
  OrgMemberDto,
  OrgMemberLabelDto,
  OrgMemberLabelListResponseDto,
  OrgMessagesControllerListDetailsParams,
  OrgMessagesControllerListParams,
  OrgOriginatorsControllerListParams,
  OrgOriginatorsControllerListReusableDocumentsParams,
  OrgPermissionDto,
  OrgPermissionGrantResultDto,
  OrgPermissionListResponseDto,
  OrgPermissionScopesResponseDto,
  OrgSummaryDto,
  OrgTeamDetailDto,
  OrgTeamDto,
  OriginatorDocumentDownloadUrlDto,
  OriginatorDto,
  OriginatorsControllerListParams,
  OriginatorsControllerListReusableDocumentsParams,
  PutStaffMemberRoleBodyDto,
  RefreshTokenBodyDto,
  RegisterOrgDocumentBodyDto,
  RegisterOrgDocumentResponseDto,
  ReinviteResultDto,
  ReissueManagedCredentialBodyDto,
  ReissuedManagedCredentialDto,
  RenameOrgTeamBodyDto,
  ReusableDocumentsResponseDto,
  SchoolbellOrgLinkAuthorizeUrlDto,
  SchoolbellOrgLinkCallbackResponseDto,
  SchoolbellOrgLinkScopeStatusDto,
  SmsStoreEnterTokenResponseDto,
  SpinoffNotificationsControllerListParams,
  SpinoffOrgMembersControllerListAuditLogParams,
  SpinoffOrgMembersControllerListInvitationsParams,
  SpinoffOrgMembersControllerListMembersParams,
  SpinoffOrgTeamsControllerListTeamMembersParams,
  SpinoffOrgsControllerListMyOrgsParams,
  StaffAuditLogsControllerListParams,
  StaffAuditLogsResponseDto,
  StaffDocumentDownloadUrlDto,
  StaffInvitationDto,
  StaffLinkOrgProviderDto,
  StaffLinkedOrgDto,
  StaffListDocumentsResponseDto,
  StaffListMessageAttachmentsResponseDto,
  StaffListMessagesResponseDto,
  StaffListOriginatorsResponseDto,
  StaffMeDto,
  StaffMemberDto,
  StaffMemberRoleChangeDto,
  StaffMemberScopeChangeDto,
  StaffMembersControllerListParams,
  StaffMembersPageDto,
  StaffMessageAttachmentDownloadUrlDto,
  StaffMessagesControllerListParams,
  StaffOrgProviderLinkControllerSearchUnlinkedParams,
  StaffOriginatorDto,
  StaffOriginatorsControllerListParams,
  StaffReconcileLinkSeatsDto,
  StaffReconcileLinkSeatsResultDto,
  StaffRejectOriginatorDto,
  StaffScopeBookDto,
  StaffTwoFactorAuthChallengesResponseDto,
  StaffUnlinkedOrgDto,
  StaffUserLookupResponseDto,
  StaffUsersControllerListChallengesParams,
  StaffUsersControllerLookupParams,
  TemplateDto,
  TwoFactorAuthChallengeResponseDto,
  TwoFactorAuthStatusResponseDto,
  TwoFactorAuthVerifyResponseDto,
  UnreadCountResponseDto,
  UpdateMemberSortKeyBodyDto,
  UpdateMessageBodyDto,
  UpdateOrgMemberBodyDto,
  UpdateOrgMemberLabelDto,
  UpdateOriginatorBodyDto,
  UpdateTeamMemberRoleBodyDto,
  UpdateTemplateBodyDto,
  UploadMessageAttachmentResponseDto,
  UploadUrlBodyDto,
  UploadUrlResponseDto,
  VerifyTwoFactorAuthChallengeBodyDto
} from './models';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value.filter(
        (item) =>
          item != null &&
          (typeof item === 'string' ||
            typeof item === 'number' ||
            typeof item === 'boolean'),
      ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class SbeSmsApiService {
  private readonly http = inject(HttpClient);
/**
 * 짧은 수명(기본 60초, 최대 300초)·1회용 불투명 입장 토큰을 발급한다. provider 는 경로가 정한다.
 * @summary 입장 토큰 발급 (provider API 키)
 */
 magicLinkEntryIssueControllerIssue<TData = MagicLinkEntryResponseDto>(provider: string,
    issueMagicLinkEntryDto: IssueMagicLinkEntryDto, options?: HttpClientBodyOptions): Observable<TData>;
 magicLinkEntryIssueControllerIssue<TData = MagicLinkEntryResponseDto>(provider: string,
    issueMagicLinkEntryDto: IssueMagicLinkEntryDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 magicLinkEntryIssueControllerIssue<TData = MagicLinkEntryResponseDto>(provider: string,
    issueMagicLinkEntryDto: IssueMagicLinkEntryDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  magicLinkEntryIssueControllerIssue<TData = MagicLinkEntryResponseDto>(
    provider: string,
    issueMagicLinkEntryDto: IssueMagicLinkEntryDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/magic-link/${provider}/entry-tokens`,
      issueMagicLinkEntryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/magic-link/${provider}/entry-tokens`,
      issueMagicLinkEntryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/magic-link/${provider}/entry-tokens`,
      issueMagicLinkEntryDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 내 프로필 조회
 */
 spinoffSessionControllerMe<TData = MeResponseDto>( options?: HttpClientBodyOptions): Observable<TData>;
 spinoffSessionControllerMe<TData = MeResponseDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffSessionControllerMe<TData = MeResponseDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffSessionControllerMe<TData = MeResponseDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/auth/me`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/auth/me`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/auth/me`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary org access token 발급 — 현재 유효한 세션(personal/org 무관)으로 대상 org의 파생 access token을 발급한다. 세션 교체·쿠키 조작·refresh 발급 없음(stateless).
 */
 spinoffSessionControllerOrgToken<TData = OrgAccessTokenResponseDto>(orgAccessTokenBodyDto: OrgAccessTokenBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffSessionControllerOrgToken<TData = OrgAccessTokenResponseDto>(orgAccessTokenBodyDto: OrgAccessTokenBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffSessionControllerOrgToken<TData = OrgAccessTokenResponseDto>(orgAccessTokenBodyDto: OrgAccessTokenBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffSessionControllerOrgToken<TData = OrgAccessTokenResponseDto>(
    orgAccessTokenBodyDto: OrgAccessTokenBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/org-token`,
      orgAccessTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/org-token`,
      orgAccessTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/org-token`,
      orgAccessTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary refresh token 회전 — HttpOnly 쿠키(일반 로그인) 또는 body(매직링크 유래 sessionStorage 세션) 중 실제로 요청이 쓴 채널로만 응답한다(전송 채널 미러링, 쿠키 없이 body로 오면 쿠키를 세팅하지 않는다).
 */
 spinoffSessionControllerRefresh<TData = IssuedSessionResponseDto>(refreshTokenBodyDto: RefreshTokenBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffSessionControllerRefresh<TData = IssuedSessionResponseDto>(refreshTokenBodyDto: RefreshTokenBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffSessionControllerRefresh<TData = IssuedSessionResponseDto>(refreshTokenBodyDto: RefreshTokenBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffSessionControllerRefresh<TData = IssuedSessionResponseDto>(
    refreshTokenBodyDto: RefreshTokenBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/refresh`,
      refreshTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/refresh`,
      refreshTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/refresh`,
      refreshTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 로그아웃 (refresh token 폐기) — 쿠키 또는 body 중 요청이 쓴 채널만 정리한다(전송 채널 미러링). body로 왔으면 쿠키는 건드리지 않는다 — 다른 탭의 개인 로그인 세션을 지켜야 한다.
 */
 spinoffSessionControllerSignout<TData = void>(refreshTokenBodyDto: RefreshTokenBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffSessionControllerSignout<TData = void>(refreshTokenBodyDto: RefreshTokenBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffSessionControllerSignout<TData = void>(refreshTokenBodyDto: RefreshTokenBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffSessionControllerSignout<TData = void>(
    refreshTokenBodyDto: RefreshTokenBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/signout`,
      refreshTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/signout`,
      refreshTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/signout`,
      refreshTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * redirect_uri가 로그인과 공유되므로 소비 앱 web이 sessionStorage intent로 이 엔드포인트에 포워딩할지 판단한다. 응답은 { orgId, returnUrl, newlyLinked } — SPA가 returnUrl로 navigate한다(newlyLinked 는 신규 연결이면 true, 재동의면 false).
 * @summary 소비 앱 web 콜백 라우트가 code+state를 포워딩 — token 교환 → 단체 연결 + grant 저장
 */
 schoolbellOrgLinkControllerOidcCallback<TData = SchoolbellOrgLinkCallbackResponseDto>( options?: HttpClientBodyOptions): Observable<TData>;
 schoolbellOrgLinkControllerOidcCallback<TData = SchoolbellOrgLinkCallbackResponseDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 schoolbellOrgLinkControllerOidcCallback<TData = SchoolbellOrgLinkCallbackResponseDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  schoolbellOrgLinkControllerOidcCallback<TData = SchoolbellOrgLinkCallbackResponseDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/auth/sso/schoolbell-e/org-link/callback`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/auth/sso/schoolbell-e/org-link/callback`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/auth/sso/schoolbell-e/org-link/callback`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * spinoff 자체 로그인 토큰 또는 schoolbell-e org-위임 compound token(`org.sms.send` 스코프) 수락.
 * @summary SMS 크레딧 잔액 조회 (커머스 AssetVault 위임)
 */
 balanceControllerGetBalance<TData = BalanceResponseDto>( options?: HttpClientBodyOptions): Observable<TData>;
 balanceControllerGetBalance<TData = BalanceResponseDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 balanceControllerGetBalance<TData = BalanceResponseDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  balanceControllerGetBalance<TData = BalanceResponseDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/balance`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/balance`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/balance`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary RP Order 생성 → 결제 페이지 URL 반환 (orderId만으로 무인증 접근)
 */
 creditsCheckoutControllerCheckout<TData = CheckoutResponseDto>(checkoutRequestDto: CheckoutRequestDto, options?: HttpClientBodyOptions): Observable<TData>;
 creditsCheckoutControllerCheckout<TData = CheckoutResponseDto>(checkoutRequestDto: CheckoutRequestDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 creditsCheckoutControllerCheckout<TData = CheckoutResponseDto>(checkoutRequestDto: CheckoutRequestDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  creditsCheckoutControllerCheckout<TData = CheckoutResponseDto>(
    checkoutRequestDto: CheckoutRequestDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/credits/checkout`,
      checkoutRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/credits/checkout`,
      checkoutRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/credits/checkout`,
      checkoutRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary SMS 크레딧 소모/충전 이력 조회 (커머스 CreditLedger 위임)
 */
 creditsHistoryControllerGetHistory<TData = CreditsHistoryResponseDto>(params?: CreditsHistoryControllerGetHistoryParams, options?: HttpClientBodyOptions): Observable<TData>;
 creditsHistoryControllerGetHistory<TData = CreditsHistoryResponseDto>(params?: CreditsHistoryControllerGetHistoryParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 creditsHistoryControllerGetHistory<TData = CreditsHistoryResponseDto>(params?: CreditsHistoryControllerGetHistoryParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  creditsHistoryControllerGetHistory<TData = CreditsHistoryResponseDto>(
    params?: CreditsHistoryControllerGetHistoryParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/credits/history`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/credits/history`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/credits/history`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary SMS 크레딧 상품 목록 조회
 */
 creditsOffersControllerGetOffers<TData = CreditOfferDto[]>( options?: HttpClientBodyOptions): Observable<TData>;
 creditsOffersControllerGetOffers<TData = CreditOfferDto[]>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 creditsOffersControllerGetOffers<TData = CreditOfferDto[]>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  creditsOffersControllerGetOffers<TData = CreditOfferDto[]>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/credits/offers`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/credits/offers`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/credits/offers`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary SMS 크레딧 구매(주문) 이력 조회 (커머스 Order 위임)
 */
 creditsOrdersControllerGetOrders<TData = CreditsOrdersResponseDto>(params?: CreditsOrdersControllerGetOrdersParams, options?: HttpClientBodyOptions): Observable<TData>;
 creditsOrdersControllerGetOrders<TData = CreditsOrdersResponseDto>(params?: CreditsOrdersControllerGetOrdersParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 creditsOrdersControllerGetOrders<TData = CreditsOrdersResponseDto>(params?: CreditsOrdersControllerGetOrdersParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  creditsOrdersControllerGetOrders<TData = CreditsOrdersResponseDto>(
    params?: CreditsOrdersControllerGetOrdersParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/credits/orders`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/credits/orders`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/credits/orders`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

 rootControllerHealth<TData = HealthResponseDto>( options?: HttpClientBodyOptions): Observable<TData>;
 rootControllerHealth<TData = HealthResponseDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 rootControllerHealth<TData = HealthResponseDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  rootControllerHealth<TData = HealthResponseDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/health`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/health`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/health`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 내게 온 단체 초대 목록 (Pending)
 */
 spinoffOrgMembersControllerListMyInvitations<TData = ListOrgInvitationsResponseDto>( options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMembersControllerListMyInvitations<TData = ListOrgInvitationsResponseDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMembersControllerListMyInvitations<TData = ListOrgInvitationsResponseDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMembersControllerListMyInvitations<TData = ListOrgInvitationsResponseDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/me/org-invitations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/me/org-invitations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/me/org-invitations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 이미 수락했으면 멱등 성공(같은 응답). 응답의 `orgId` 는 소유 단체다.
 * @summary 단체 초대 수락
 */
 spinoffOrgMembersControllerAcceptInvitation<TData = OrgInvitationResponseDto>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMembersControllerAcceptInvitation<TData = OrgInvitationResponseDto>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMembersControllerAcceptInvitation<TData = OrgInvitationResponseDto>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMembersControllerAcceptInvitation<TData = OrgInvitationResponseDto>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/me/org-invitations/${id}/accept`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/me/org-invitations/${id}/accept`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/me/org-invitations/${id}/accept`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 이미 거절했으면 멱등 성공(같은 응답). 응답의 `orgId` 는 소유 단체다.
 * @summary 단체 초대 거절
 */
 spinoffOrgMembersControllerRejectInvitation<TData = OrgInvitationResponseDto>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMembersControllerRejectInvitation<TData = OrgInvitationResponseDto>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMembersControllerRejectInvitation<TData = OrgInvitationResponseDto>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMembersControllerRejectInvitation<TData = OrgInvitationResponseDto>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/me/org-invitations/${id}/reject`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/me/org-invitations/${id}/reject`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/me/org-invitations/${id}/reject`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 수락한 본인이 스스로 이 연결에서 떠난다(Left). `:assignmentId`는 내 멤버십 응답의 `contacts[].id`. 남의 것이거나 없으면 404, 이미 떠났으면 멱등 성공(같은 응답), 수락 상태가 아니면 409 MEMBERSHIP_NOT_ACCEPTED. 단체의 마지막 수락된 org-root Owner 는 떠날 수 없다(409 LAST_ORG_OWNER — 다른 Owner 를 먼저 지정하거나 단체 해체를 사용). 응답의 `orgId` 는 소유 단체다.
 * @summary 단체 멤버십 떠나기 (본인)
 */
 spinoffOrgMembersControllerLeaveMembership<TData = OrgInvitationResponseDto>(assignmentId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMembersControllerLeaveMembership<TData = OrgInvitationResponseDto>(assignmentId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMembersControllerLeaveMembership<TData = OrgInvitationResponseDto>(assignmentId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMembersControllerLeaveMembership<TData = OrgInvitationResponseDto>(
    assignmentId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/me/org-memberships/${assignmentId}/leave`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/me/org-memberships/${assignmentId}/leave`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/me/org-memberships/${assignmentId}/leave`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * GET /orgs/:orgId/members(전체 명단, admin 전용)와 달리 이 라우트는 인증된 멤버라면 누구나 호출할 수 있다 — 결과가 항상 호출자 본인(userId)이 priority=1·active 연락처로 연결된 자리로만 제한되기 때문이다. org 직속·team 소속을 가리지 않고 그런 자리 전부를 반환한다 (보통 하나지만 여러 team에 걸쳐 있으면 여러 건일 수 있다). AuditLog 계측용 userId+actorSnapshot을 조회하려는 소비처가 주 대상이다.
 * @summary 내 자신의 단체 멤버 자리 목록 (본인 전용 — admin 가드 아님)
 */
 spinoffOrgMembersControllerListMyMemberships<TData = ListMyOrgMembersResponseDto>(orgId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMembersControllerListMyMemberships<TData = ListMyOrgMembersResponseDto>(orgId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMembersControllerListMyMemberships<TData = ListMyOrgMembersResponseDto>(orgId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMembersControllerListMyMemberships<TData = ListMyOrgMembersResponseDto>(
    orgId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/me/orgs/${orgId}/members`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/me/orgs/${orgId}/members`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/me/orgs/${orgId}/members`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * GET /orgs/:orgId/teams/:teamId/members(team 전체 명단, org admin 또는 이 team의 Owner/Admin 전용)와 달리 이 라우트는 인증된 멤버라면 누구나 호출할 수 있다 — 결과가 항상 호출자 본인(userId)의 이 teamId 소속 자리로만 제한되기 때문이다(org 전체를 보는 GET /me/orgs/:orgId/members와 동일 원칙, teamId 필터만 추가). 이 team 소속이 아니면 빈 배열을 반환한다(404/403 아님). **네이티브 `OrgTeam` 전용** — spinoff-provider-federation로 연결된 org의 schoolbell-e 라이브 team(미러링되지 않음, `OrgDirectoryService.listTeams` 참고)에만 소속된 사람은 이 teamId로 찾을 수 없다. `GET /me/orgs/:orgId/members`도 이미 같은 한계를 갖고 있다(둘 다 네이티브 `OrgMember` 전용 lean select) — 2026-09-23 신설 시점 기준 실 소비처가 없어 범위 밖으로 남겨둔다.
 * @summary 이 team에서 내 자신의 멤버 자리 조회 (본인 전용 — admin/team 가드 아님)
 */
 spinoffOrgTeamsControllerListMyTeamMemberships<TData = ListMyOrgMembersResponseDto>(orgId: string,
    teamId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgTeamsControllerListMyTeamMemberships<TData = ListMyOrgMembersResponseDto>(orgId: string,
    teamId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgTeamsControllerListMyTeamMemberships<TData = ListMyOrgMembersResponseDto>(orgId: string,
    teamId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgTeamsControllerListMyTeamMemberships<TData = ListMyOrgMembersResponseDto>(
    orgId: string,
    teamId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/me/orgs/${orgId}/teams/${teamId}/members`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/me/orgs/${orgId}/teams/${teamId}/members`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/me/orgs/${orgId}/teams/${teamId}/members`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 번호를 알 수 없는 세션은 403 `phone-required`.
 * @summary 내 번호로 온 대기 중 초대
 */
 staffInvitationsControllerListMine<TData = StaffInvitationDto[]>( options?: HttpClientBodyOptions): Observable<TData>;
 staffInvitationsControllerListMine<TData = StaffInvitationDto[]>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffInvitationsControllerListMine<TData = StaffInvitationDto[]>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffInvitationsControllerListMine<TData = StaffInvitationDto[]>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/me/staff/invitations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/me/staff/invitations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/me/staff/invitations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 내 번호가 아닌 초대는 404, 이미 처리됐으면 409 `invitation-not-pending`, 기한이 지났으면 409 `invitation-expired`.
 * @summary 내 초대 수락
 */
 staffInvitationsControllerAccept<TData = StaffInvitationDto>(invitationId: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffInvitationsControllerAccept<TData = StaffInvitationDto>(invitationId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffInvitationsControllerAccept<TData = StaffInvitationDto>(invitationId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffInvitationsControllerAccept<TData = StaffInvitationDto>(
    invitationId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/me/staff/invitations/${invitationId}/accept`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/me/staff/invitations/${invitationId}/accept`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/me/staff/invitations/${invitationId}/accept`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 내 초대 거절
 */
 staffInvitationsControllerReject<TData = StaffInvitationDto>(invitationId: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffInvitationsControllerReject<TData = StaffInvitationDto>(invitationId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffInvitationsControllerReject<TData = StaffInvitationDto>(invitationId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffInvitationsControllerReject<TData = StaffInvitationDto>(
    invitationId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/me/staff/invitations/${invitationId}/reject`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/me/staff/invitations/${invitationId}/reject`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/me/staff/invitations/${invitationId}/reject`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 팝업이 postMessage로 넘긴 code를 교환해 발송 대상(전화번호) 목록을 받는다
 */
 memberPickerControllerExchangeSession<TData = MemberPickerExchangeResultDto>(code: string, options?: HttpClientBodyOptions): Observable<TData>;
 memberPickerControllerExchangeSession<TData = MemberPickerExchangeResultDto>(code: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 memberPickerControllerExchangeSession<TData = MemberPickerExchangeResultDto>(code: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  memberPickerControllerExchangeSession<TData = MemberPickerExchangeResultDto>(
    code: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/member-picker/${code}/exchange`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/member-picker/${code}/exchange`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/member-picker/${code}/exchange`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * id 내림차순. cursor 미지정 → 첫 페이지. blind=1 (소프트 삭제) 은 제외. spinoff 자체 로그인 토큰 또는 schoolbell-e org-위임 compound token(`org.sms.send`) 수락 — compound 경로는 같은 org에 위임된 다른 client(RP)가 아니라 자신(clientId)이 보낸 것만 조회된다.
 * @summary 내 tenant 의 message 목록 (cursor 페이지네이션)
 */
 messagesControllerList<TData = ListMessagesResponseDto>(params?: MessagesControllerListParams, options?: HttpClientBodyOptions): Observable<TData>;
 messagesControllerList<TData = ListMessagesResponseDto>(params?: MessagesControllerListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 messagesControllerList<TData = ListMessagesResponseDto>(params?: MessagesControllerListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  messagesControllerList<TData = ListMessagesResponseDto>(
    params?: MessagesControllerListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/messages`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/messages`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/messages`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * message 행 생성 + sms.send.requested 발행. 발송사 호출은 워커가 비동기 처리. spinoff 자체 로그인 토큰 또는 schoolbell-e org-위임 compound token(`org.sms.send`) 수락.
 * @summary SMS 발송 요청 enqueue (§9 Phase 1)
 */
 messagesControllerCreate<TData = CreatedMessageResponseDto>(createMessageBodyDto: CreateMessageBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 messagesControllerCreate<TData = CreatedMessageResponseDto>(createMessageBodyDto: CreateMessageBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 messagesControllerCreate<TData = CreatedMessageResponseDto>(createMessageBodyDto: CreateMessageBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  messagesControllerCreate<TData = CreatedMessageResponseDto>(
    createMessageBodyDto: CreateMessageBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/messages`,
      createMessageBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/messages`,
      createMessageBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/messages`,
      createMessageBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 이미지를 업로드하면 서버가 즉시 알리고 제한(폭≤640px·높이≤1280px·장당≤300KB)에 맞게 JPEG로 리사이즈해 저장한다. 여러 장 첨부 시 이 엔드포인트를 장수만큼 반복 호출한다 (최대 3장). 응답의 fileId를 POST /messages 의 attachments 배열에 담아 발송한다. JPEG/PNG/GIF만 지원 — sharp가 실제로 디코딩한 포맷 기준(신고된 Content-Type 불신).
 * @summary MMS 첨부 이미지 업로드(1장)
 */
 messageAttachmentsControllerUpload<TData = UploadMessageAttachmentResponseDto>( options?: HttpClientBodyOptions): Observable<TData>;
 messageAttachmentsControllerUpload<TData = UploadMessageAttachmentResponseDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 messageAttachmentsControllerUpload<TData = UploadMessageAttachmentResponseDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  messageAttachmentsControllerUpload<TData = UploadMessageAttachmentResponseDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/messages/attachments`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/messages/attachments`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/messages/attachments`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * status 가 Saved/Scheduled 이 아니면 409. 워커가 fan-out 진입 직전 Cancelled 를 보면 skip.
 * @summary 예약 발송 취소 (status=Cancelled)
 */
 messagesControllerCancel<TData = void>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 messagesControllerCancel<TData = void>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 messagesControllerCancel<TData = void>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  messagesControllerCancel<TData = void>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/messages/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/messages/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/messages/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 본인 tenant 가 아니거나 blind=1 → 404. per-recipient 상태는 :id/details 사용. spinoff 자체 로그인 토큰 또는 schoolbell-e org-위임 compound token(`org.sms.send`) 수락.
 * @summary message 단건 (요약 + 원본 수신자 포함)
 */
 messagesControllerGetById<TData = MessageDetailDto>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 messagesControllerGetById<TData = MessageDetailDto>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 messagesControllerGetById<TData = MessageDetailDto>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  messagesControllerGetById<TData = MessageDetailDto>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/messages/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/messages/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/messages/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * blind=1 = 목록·상세에서 숨김. 다른 컬럼 수정은 별도 ADR.
 * @summary message.blind 토글 (소프트 삭제)
 */
 messagesControllerUpdate<TData = MessageDetailDto>(id: string,
    updateMessageBodyDto: UpdateMessageBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 messagesControllerUpdate<TData = MessageDetailDto>(id: string,
    updateMessageBodyDto: UpdateMessageBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 messagesControllerUpdate<TData = MessageDetailDto>(id: string,
    updateMessageBodyDto: UpdateMessageBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  messagesControllerUpdate<TData = MessageDetailDto>(
    id: string,
    updateMessageBodyDto: UpdateMessageBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/messages/${id}`,
      updateMessageBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/messages/${id}`,
      updateMessageBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/messages/${id}`,
      updateMessageBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * id 오름차순. 워커 fan-out 결과·발송사 status 가 들어 있다. spinoff 자체 로그인 토큰 또는 schoolbell-e org-위임 compound token(`org.sms.send`) 수락.
 * @summary 한 메시지의 수신자별 delivery 목록 (cursor 페이지네이션)
 */
 messagesControllerListDetails<TData = ListMessageDetailsResponseDto>(id: string,
    params?: MessagesControllerListDetailsParams, options?: HttpClientBodyOptions): Observable<TData>;
 messagesControllerListDetails<TData = ListMessageDetailsResponseDto>(id: string,
    params?: MessagesControllerListDetailsParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 messagesControllerListDetails<TData = ListMessageDetailsResponseDto>(id: string,
    params?: MessagesControllerListDetailsParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  messagesControllerListDetails<TData = ListMessageDetailsResponseDto>(
    id: string,
    params?: MessagesControllerListDetailsParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/messages/${id}/details`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/messages/${id}/details`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/messages/${id}/details`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary NICE 휴대폰 본인인증 시작
 */
 niceVerificationControllerInit<TData = NiceInitResponseDto>(niceInitBodyDto: NiceInitBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 niceVerificationControllerInit<TData = NiceInitResponseDto>(niceInitBodyDto: NiceInitBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 niceVerificationControllerInit<TData = NiceInitResponseDto>(niceInitBodyDto: NiceInitBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  niceVerificationControllerInit<TData = NiceInitResponseDto>(
    niceInitBodyDto: NiceInitBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/nice/init`,
      niceInitBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/nice/init`,
      niceInitBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/nice/init`,
      niceInitBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary NICE 휴대폰 본인인증 결과 확인
 */
 niceVerificationControllerVerify<TData = NiceVerifyResponseDto>(niceVerifyBodyDto: NiceVerifyBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 niceVerificationControllerVerify<TData = NiceVerifyResponseDto>(niceVerifyBodyDto: NiceVerifyBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 niceVerificationControllerVerify<TData = NiceVerifyResponseDto>(niceVerifyBodyDto: NiceVerifyBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  niceVerificationControllerVerify<TData = NiceVerifyResponseDto>(
    niceVerifyBodyDto: NiceVerifyBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/nice/verify`,
      niceVerifyBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/nice/verify`,
      niceVerifyBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/nice/verify`,
      niceVerifyBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 내 알림 목록 (최신순)
 */
 spinoffNotificationsControllerList<TData = ListNotificationsResponseDto>(params?: SpinoffNotificationsControllerListParams, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffNotificationsControllerList<TData = ListNotificationsResponseDto>(params?: SpinoffNotificationsControllerListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffNotificationsControllerList<TData = ListNotificationsResponseDto>(params?: SpinoffNotificationsControllerListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffNotificationsControllerList<TData = ListNotificationsResponseDto>(
    params?: SpinoffNotificationsControllerListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/notifications`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/notifications`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/notifications`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 알림 열음 보고 — 멱등, 받음 보고가 없었어도 받음으로 간주해 함께 기록. 없거나 남의 것이면 404
 */
 spinoffNotificationsControllerReportOpened<TData = void>(deliveryId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffNotificationsControllerReportOpened<TData = void>(deliveryId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffNotificationsControllerReportOpened<TData = void>(deliveryId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffNotificationsControllerReportOpened<TData = void>(
    deliveryId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/notifications/deliveries/${deliveryId}/opened`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/notifications/deliveries/${deliveryId}/opened`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/notifications/deliveries/${deliveryId}/opened`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 알림 수신(받음) 보고 — 멱등. 없거나 남의 것이면 404, 이미 처리됐거나 실패·건너뜀으로 확정된 발송이면 그대로 성공
 */
 spinoffNotificationsControllerReportReceived<TData = void>(deliveryId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffNotificationsControllerReportReceived<TData = void>(deliveryId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffNotificationsControllerReportReceived<TData = void>(deliveryId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffNotificationsControllerReportReceived<TData = void>(
    deliveryId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/notifications/deliveries/${deliveryId}/received`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/notifications/deliveries/${deliveryId}/received`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/notifications/deliveries/${deliveryId}/received`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 알림 받음/열음 보고 (메시지별 토큰, 인증 헤더 없음) — 멱등. 토큰이 유효하면 항상 204, 서명·만료·형식 오류는 사유와 무관하게 401
 */
 spinoffNotificationDeliveryReportControllerReport<TData = void>(deliveryReportByTokenBodyDto: DeliveryReportByTokenBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffNotificationDeliveryReportControllerReport<TData = void>(deliveryReportByTokenBodyDto: DeliveryReportByTokenBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffNotificationDeliveryReportControllerReport<TData = void>(deliveryReportByTokenBodyDto: DeliveryReportByTokenBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffNotificationDeliveryReportControllerReport<TData = void>(
    deliveryReportByTokenBodyDto: DeliveryReportByTokenBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/notifications/delivery-reports`,
      deliveryReportByTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/notifications/delivery-reports`,
      deliveryReportByTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/notifications/delivery-reports`,
      deliveryReportByTokenBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 내 안읽음 알림 전체 읽음 처리
 */
 spinoffNotificationsControllerMarkAllRead<TData = MarkAllNotificationsReadResponseDto>( options?: HttpClientBodyOptions): Observable<TData>;
 spinoffNotificationsControllerMarkAllRead<TData = MarkAllNotificationsReadResponseDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffNotificationsControllerMarkAllRead<TData = MarkAllNotificationsReadResponseDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffNotificationsControllerMarkAllRead<TData = MarkAllNotificationsReadResponseDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/notifications/read-all`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/notifications/read-all`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/notifications/read-all`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 내 안읽음 알림 개수
 */
 spinoffNotificationsControllerUnreadCount<TData = UnreadCountResponseDto>( options?: HttpClientBodyOptions): Observable<TData>;
 spinoffNotificationsControllerUnreadCount<TData = UnreadCountResponseDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffNotificationsControllerUnreadCount<TData = UnreadCountResponseDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffNotificationsControllerUnreadCount<TData = UnreadCountResponseDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/notifications/unread-count`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/notifications/unread-count`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/notifications/unread-count`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 알림 1건 읽음 처리 (멱등 — 이미 읽었으면 그대로 성공, 남의 알림이면 404)
 */
 spinoffNotificationsControllerMarkRead<TData = void>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffNotificationsControllerMarkRead<TData = void>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffNotificationsControllerMarkRead<TData = void>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffNotificationsControllerMarkRead<TData = void>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/notifications/${id}/read`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/notifications/${id}/read`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/notifications/${id}/read`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 내가 속한 단체 목록 (adminOnly=true면 Owner/Admin인 단체만)
 */
 spinoffOrgsControllerListMyOrgs<TData = ListOrgsResponseDto>(params?: SpinoffOrgsControllerListMyOrgsParams, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgsControllerListMyOrgs<TData = ListOrgsResponseDto>(params?: SpinoffOrgsControllerListMyOrgsParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgsControllerListMyOrgs<TData = ListOrgsResponseDto>(params?: SpinoffOrgsControllerListMyOrgsParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgsControllerListMyOrgs<TData = ListOrgsResponseDto>(
    params?: SpinoffOrgsControllerListMyOrgsParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/orgs`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 단체 신설
 */
 spinoffOrgsControllerCreateOrg<TData = OrgSummaryDto>(createOrgBodyDto: CreateOrgBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgsControllerCreateOrg<TData = OrgSummaryDto>(createOrgBodyDto: CreateOrgBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgsControllerCreateOrg<TData = OrgSummaryDto>(createOrgBodyDto: CreateOrgBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgsControllerCreateOrg<TData = OrgSummaryDto>(
    createOrgBodyDto: CreateOrgBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs`,
      createOrgBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs`,
      createOrgBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs`,
      createOrgBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 연동된 단체는 이 경로로 삭제할 수 없다 — 이미 SOT 쪽 신호(연동 해제/해체 감지)로만 자동 처리되는 별도 경로가 있다. 하위 team까지 함께 삭제되고(OrgMember는 범위 밖, 기존 org 해체와 동일 scope), 이미 삭제된 단체를 다시 호출하면 멱등 응답한다.
 * @summary 단체 삭제 (org owner 본인 전용) — provider(schoolbell-e 등) 연동이 없는 단체에만 허용
 */
 spinoffOrgsControllerDissolveOrg<TData = DeleteOrgResultDto>(orgId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgsControllerDissolveOrg<TData = DeleteOrgResultDto>(orgId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgsControllerDissolveOrg<TData = DeleteOrgResultDto>(orgId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgsControllerDissolveOrg<TData = DeleteOrgResultDto>(
    orgId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/orgs/${orgId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/orgs/${orgId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/orgs/${orgId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 상세 (멤버 목록 없음 — GET /orgs/:orgId/members 별도)
 */
 spinoffOrgsControllerGetOrg<TData = OrgDto>(orgId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgsControllerGetOrg<TData = OrgDto>(orgId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgsControllerGetOrg<TData = OrgDto>(orgId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgsControllerGetOrg<TData = OrgDto>(
    orgId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 누가(actor)·언제(createdAt)·무엇을(action) 바꿨는지 최신순으로 반환한다. actor의 실명은 이 응답에 없다 — userId가 있으면 GET /orgs/:orgId/members 응답에서 같은 userId를 찾아 화면에서 매핑한다(별도 조인 없음). offset 페이지네이션(10001 cap) — page/size로 넘긴다.
 * @summary 단체 멤버/팀 변경 감사 로그 (org admin 전용)
 */
 spinoffOrgMembersControllerListAuditLog<TData = ListOrgAuditLogResponseDto>(orgId: string,
    params?: SpinoffOrgMembersControllerListAuditLogParams, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMembersControllerListAuditLog<TData = ListOrgAuditLogResponseDto>(orgId: string,
    params?: SpinoffOrgMembersControllerListAuditLogParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMembersControllerListAuditLog<TData = ListOrgAuditLogResponseDto>(orgId: string,
    params?: SpinoffOrgMembersControllerListAuditLogParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMembersControllerListAuditLog<TData = ListOrgAuditLogResponseDto>(
    orgId: string,
    params?: SpinoffOrgMembersControllerListAuditLogParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/audit-log`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/audit-log`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/audit-log`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 단체 컨텍스트 SMS 크레딧 잔액 조회 (커머스 AssetVault 위임)
 */
 orgBalanceControllerGetBalance<TData = BalanceResponseDto>(orgId: unknown, options?: HttpClientBodyOptions): Observable<TData>;
 orgBalanceControllerGetBalance<TData = BalanceResponseDto>(orgId: unknown, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgBalanceControllerGetBalance<TData = BalanceResponseDto>(orgId: unknown, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgBalanceControllerGetBalance<TData = BalanceResponseDto>(
    orgId: unknown, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/balance`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/balance`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/balance`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 컨텍스트 크레딧 충전 — RP Order 생성 → 결제 페이지 URL 반환 (orderId만으로 무인증 접근)
 */
 orgCreditsCheckoutControllerCheckout<TData = CheckoutResponseDto>(orgId: string,
    checkoutRequestDto: CheckoutRequestDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgCreditsCheckoutControllerCheckout<TData = CheckoutResponseDto>(orgId: string,
    checkoutRequestDto: CheckoutRequestDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgCreditsCheckoutControllerCheckout<TData = CheckoutResponseDto>(orgId: string,
    checkoutRequestDto: CheckoutRequestDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgCreditsCheckoutControllerCheckout<TData = CheckoutResponseDto>(
    orgId: string,
    checkoutRequestDto: CheckoutRequestDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/credits/checkout`,
      checkoutRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/credits/checkout`,
      checkoutRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/credits/checkout`,
      checkoutRequestDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 관리자 전용 — 단체 포인트를 팀원에게 분배
 */
 orgCreditsDistributionControllerDistribute<TData = OrgCreditTransferResultDto>(orgId: string,
    orgCreditTransferBodyDto: OrgCreditTransferBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgCreditsDistributionControllerDistribute<TData = OrgCreditTransferResultDto>(orgId: string,
    orgCreditTransferBodyDto: OrgCreditTransferBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgCreditsDistributionControllerDistribute<TData = OrgCreditTransferResultDto>(orgId: string,
    orgCreditTransferBodyDto: OrgCreditTransferBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgCreditsDistributionControllerDistribute<TData = OrgCreditTransferResultDto>(
    orgId: string,
    orgCreditTransferBodyDto: OrgCreditTransferBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/credits/distribute`,
      orgCreditTransferBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/credits/distribute`,
      orgCreditTransferBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/credits/distribute`,
      orgCreditTransferBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 컨텍스트 SMS 크레딧 소모/충전 이력 조회 (커머스 CreditLedger 위임)
 */
 orgCreditsHistoryControllerGetHistory<TData = CreditsHistoryResponseDto>(orgId: string,
    params?: OrgCreditsHistoryControllerGetHistoryParams, options?: HttpClientBodyOptions): Observable<TData>;
 orgCreditsHistoryControllerGetHistory<TData = CreditsHistoryResponseDto>(orgId: string,
    params?: OrgCreditsHistoryControllerGetHistoryParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgCreditsHistoryControllerGetHistory<TData = CreditsHistoryResponseDto>(orgId: string,
    params?: OrgCreditsHistoryControllerGetHistoryParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgCreditsHistoryControllerGetHistory<TData = CreditsHistoryResponseDto>(
    orgId: string,
    params?: OrgCreditsHistoryControllerGetHistoryParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/credits/history`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/credits/history`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/credits/history`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 단체 관리자 전용 — 팀원별 개인 크레딧 잔액 목록
 */
 orgCreditsDistributionControllerListMembers<TData = ListOrgMemberBalancesResponseDto>(orgId: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgCreditsDistributionControllerListMembers<TData = ListOrgMemberBalancesResponseDto>(orgId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgCreditsDistributionControllerListMembers<TData = ListOrgMemberBalancesResponseDto>(orgId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgCreditsDistributionControllerListMembers<TData = ListOrgMemberBalancesResponseDto>(
    orgId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/credits/members`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/credits/members`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/credits/members`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 컨텍스트 SMS 크레딧 구매(주문) 이력 조회 (커머스 Order 위임)
 */
 orgCreditsOrdersControllerGetOrders<TData = CreditsOrdersResponseDto>(orgId: string,
    params?: OrgCreditsOrdersControllerGetOrdersParams, options?: HttpClientBodyOptions): Observable<TData>;
 orgCreditsOrdersControllerGetOrders<TData = CreditsOrdersResponseDto>(orgId: string,
    params?: OrgCreditsOrdersControllerGetOrdersParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgCreditsOrdersControllerGetOrders<TData = CreditsOrdersResponseDto>(orgId: string,
    params?: OrgCreditsOrdersControllerGetOrdersParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgCreditsOrdersControllerGetOrders<TData = CreditsOrdersResponseDto>(
    orgId: string,
    params?: OrgCreditsOrdersControllerGetOrdersParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/credits/orders`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/credits/orders`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/credits/orders`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 단체 관리자 전용 — 팀원에게 분배된 포인트 회수
 */
 orgCreditsDistributionControllerReclaim<TData = OrgCreditTransferResultDto>(orgId: string,
    orgCreditTransferBodyDto: OrgCreditTransferBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgCreditsDistributionControllerReclaim<TData = OrgCreditTransferResultDto>(orgId: string,
    orgCreditTransferBodyDto: OrgCreditTransferBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgCreditsDistributionControllerReclaim<TData = OrgCreditTransferResultDto>(orgId: string,
    orgCreditTransferBodyDto: OrgCreditTransferBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgCreditsDistributionControllerReclaim<TData = OrgCreditTransferResultDto>(
    orgId: string,
    orgCreditTransferBodyDto: OrgCreditTransferBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/credits/reclaim`,
      orgCreditTransferBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/credits/reclaim`,
      orgCreditTransferBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/credits/reclaim`,
      orgCreditTransferBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * status=pending(미응답, 기본)·declined(거절). 오래 기다린 순이며 pending 은 `daysWaiting`(조회 시점 파생)을 준다. 거절 목록은 이후 다시 초대됐거나 가입한 사람을 제외한다. 연결이 10000건을 넘으면 앞쪽만 훑고 `truncated=true`.
 * @summary 관리자 초대 현황 (미응답·거절)
 */
 spinoffOrgMembersControllerListInvitations<TData = ListOrgInvitationsAdminResponseDto>(orgId: string,
    params?: SpinoffOrgMembersControllerListInvitationsParams, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMembersControllerListInvitations<TData = ListOrgInvitationsAdminResponseDto>(orgId: string,
    params?: SpinoffOrgMembersControllerListInvitationsParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMembersControllerListInvitations<TData = ListOrgInvitationsAdminResponseDto>(orgId: string,
    params?: SpinoffOrgMembersControllerListInvitationsParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMembersControllerListInvitations<TData = ListOrgInvitationsAdminResponseDto>(
    orgId: string,
    params?: SpinoffOrgMembersControllerListInvitationsParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/invitations`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/invitations`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/invitations`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 단체 멤버 초대 (이메일 또는 전화번호)
 */
 spinoffOrgMembersControllerInviteMember<TData = OrgInvitationSentDto>(orgId: string,
    inviteOrgMemberBodyDto: InviteOrgMemberBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMembersControllerInviteMember<TData = OrgInvitationSentDto>(orgId: string,
    inviteOrgMemberBodyDto: InviteOrgMemberBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMembersControllerInviteMember<TData = OrgInvitationSentDto>(orgId: string,
    inviteOrgMemberBodyDto: InviteOrgMemberBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMembersControllerInviteMember<TData = OrgInvitationSentDto>(
    orgId: string,
    inviteOrgMemberBodyDto: InviteOrgMemberBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/invitations`,
      inviteOrgMemberBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/invitations`,
      inviteOrgMemberBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/invitations`,
      inviteOrgMemberBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 닫힌(Rejected·Left·Removed) 연결을 새 `invite()` 와 같은 방식으로 다시 초대한다(새 연결이 만들어진다). Pending/Accepted 는 409 REINVITE_NOT_ALLOWED(reason: ALREADY_PENDING/ALREADY_JOINED/ALREADY_MEMBER), 마지막 초대 후 24시간 이내면 409 REINVITE_COOLDOWN(availableAt).
 * @summary 재초대 (거절·떠남·제거된 연결)
 */
 spinoffOrgMembersControllerReinvite<TData = ReinviteResultDto>(orgId: string,
    assignmentId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMembersControllerReinvite<TData = ReinviteResultDto>(orgId: string,
    assignmentId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMembersControllerReinvite<TData = ReinviteResultDto>(orgId: string,
    assignmentId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMembersControllerReinvite<TData = ReinviteResultDto>(
    orgId: string,
    assignmentId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/invitations/${assignmentId}/reinvite`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/invitations/${assignmentId}/reinvite`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/invitations/${assignmentId}/reinvite`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 단체(Owner·Admin)가 멤버 자리와 그 자리 앞의 소유 계정을 한 번에 만든다. 초대·수락 없이 즉시 활성(Accepted)이며 역할은 Member로 고정이다. 응답의 `login.code`는 **이 응답에서 한 번만** 볼 수 있다(서버는 해시만 저장) — 학교가 학생에게 나눠 준다. 소유 계정에는 전화번호·이메일·소셜 로그인·비밀번호를 붙일 수 없다. 별도 삭제 API는 없다 — 자리를 제거하거나 단체를 해산하면 계정도 함께 삭제된다.
 * @summary 단체 소유 멤버 생성 (전화번호·이메일 없이 로그인 코드로만 로그인하는 빈 계정 + 멤버 자리)
 */
 spinoffOrgMembersControllerCreateManagedUser<TData = CreatedManagedUserDto>(orgId: string,
    createManagedUserBodyDto: CreateManagedUserBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMembersControllerCreateManagedUser<TData = CreatedManagedUserDto>(orgId: string,
    createManagedUserBodyDto: CreateManagedUserBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMembersControllerCreateManagedUser<TData = CreatedManagedUserDto>(orgId: string,
    createManagedUserBodyDto: CreateManagedUserBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMembersControllerCreateManagedUser<TData = CreatedManagedUserDto>(
    orgId: string,
    createManagedUserBodyDto: CreateManagedUserBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/managed-users`,
      createManagedUserBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/managed-users`,
      createManagedUserBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/managed-users`,
      createManagedUserBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 이름 목록으로 소유 계정을 한꺼번에 만든다. 한 요청이 한 트랜잭션이라 전부 만들어지거나 하나도 만들어지지 않는다(실패 후 재시도가 중복을 만들지 않는다). 응답의 각 `login.code`는 **이 응답에서 한 번만** 볼 수 있으므로 호출한 화면이 바로 인쇄·저장하게 해야 한다. 200명을 넘는 인원은 호출 측이 200명씩 나눠 순서대로 보낸다(일괄 쓰기 한도: 분당 10회).
 * @summary 단체 소유 멤버 일괄 생성 (한 학교 학생 수백~수천 명용 — 요청당 최대 200명)
 */
 spinoffOrgMembersControllerBatchManagedUsers<TData = BatchManagedUsersResultDto>(orgId: string,
    batchManagedUsersBodyDto: BatchManagedUsersBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMembersControllerBatchManagedUsers<TData = BatchManagedUsersResultDto>(orgId: string,
    batchManagedUsersBodyDto: BatchManagedUsersBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMembersControllerBatchManagedUsers<TData = BatchManagedUsersResultDto>(orgId: string,
    batchManagedUsersBodyDto: BatchManagedUsersBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMembersControllerBatchManagedUsers<TData = BatchManagedUsersResultDto>(
    orgId: string,
    batchManagedUsersBodyDto: BatchManagedUsersBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/managed-users/batch`,
      batchManagedUsersBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/managed-users/batch`,
      batchManagedUsersBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/managed-users/batch`,
      batchManagedUsersBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 커스텀 라벨 카탈로그 조회 (org admin 전용)
 */
 spinoffOrgMemberLabelsControllerList<TData = OrgMemberLabelListResponseDto>(orgId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMemberLabelsControllerList<TData = OrgMemberLabelListResponseDto>(orgId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMemberLabelsControllerList<TData = OrgMemberLabelListResponseDto>(orgId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMemberLabelsControllerList<TData = OrgMemberLabelListResponseDto>(
    orgId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/member-labels`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/member-labels`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/member-labels`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 커스텀 라벨 생성 (org admin 전용)
 */
 spinoffOrgMemberLabelsControllerCreate<TData = OrgMemberLabelDto>(orgId: string,
    createOrgMemberLabelDto: CreateOrgMemberLabelDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMemberLabelsControllerCreate<TData = OrgMemberLabelDto>(orgId: string,
    createOrgMemberLabelDto: CreateOrgMemberLabelDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMemberLabelsControllerCreate<TData = OrgMemberLabelDto>(orgId: string,
    createOrgMemberLabelDto: CreateOrgMemberLabelDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMemberLabelsControllerCreate<TData = OrgMemberLabelDto>(
    orgId: string,
    createOrgMemberLabelDto: CreateOrgMemberLabelDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/member-labels`,
      createOrgMemberLabelDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/member-labels`,
      createOrgMemberLabelDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/member-labels`,
      createOrgMemberLabelDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 커스텀 라벨 삭제 (org admin 전용) — 배정·권한도 함께 삭제된다
 */
 spinoffOrgMemberLabelsControllerRemove<TData = void>(orgId: string,
    labelId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMemberLabelsControllerRemove<TData = void>(orgId: string,
    labelId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMemberLabelsControllerRemove<TData = void>(orgId: string,
    labelId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMemberLabelsControllerRemove<TData = void>(
    orgId: string,
    labelId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/member-labels/${labelId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/member-labels/${labelId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/orgs/${orgId}/member-labels/${labelId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 커스텀 라벨 이름 변경 (org admin 전용)
 */
 spinoffOrgMemberLabelsControllerRename<TData = OrgMemberLabelDto>(orgId: string,
    labelId: string,
    updateOrgMemberLabelDto: UpdateOrgMemberLabelDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMemberLabelsControllerRename<TData = OrgMemberLabelDto>(orgId: string,
    labelId: string,
    updateOrgMemberLabelDto: UpdateOrgMemberLabelDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMemberLabelsControllerRename<TData = OrgMemberLabelDto>(orgId: string,
    labelId: string,
    updateOrgMemberLabelDto: UpdateOrgMemberLabelDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMemberLabelsControllerRename<TData = OrgMemberLabelDto>(
    orgId: string,
    labelId: string,
    updateOrgMemberLabelDto: UpdateOrgMemberLabelDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/member-labels/${labelId}`,
      updateOrgMemberLabelDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/member-labels/${labelId}`,
      updateOrgMemberLabelDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/orgs/${orgId}/member-labels/${labelId}`,
      updateOrgMemberLabelDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 커스텀 라벨을 특정 대상에 배정 (org admin 전용)
 */
 spinoffOrgMemberLabelsControllerAssign<TData = void>(orgId: string,
    labelId: string,
    assignOrgMemberLabelDto: AssignOrgMemberLabelDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMemberLabelsControllerAssign<TData = void>(orgId: string,
    labelId: string,
    assignOrgMemberLabelDto: AssignOrgMemberLabelDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMemberLabelsControllerAssign<TData = void>(orgId: string,
    labelId: string,
    assignOrgMemberLabelDto: AssignOrgMemberLabelDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMemberLabelsControllerAssign<TData = void>(
    orgId: string,
    labelId: string,
    assignOrgMemberLabelDto: AssignOrgMemberLabelDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/member-labels/${labelId}/assignments`,
      assignOrgMemberLabelDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/member-labels/${labelId}/assignments`,
      assignOrgMemberLabelDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/member-labels/${labelId}/assignments`,
      assignOrgMemberLabelDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 커스텀 라벨 배정을 배치로 추가/해제 (org admin 전용) — 배치당 audit log 1건
 */
 spinoffOrgMemberLabelsControllerBatchUpdateAssignments<TData = void>(orgId: string,
    labelId: string,
    batchUpdateOrgMemberLabelAssignmentsDto: BatchUpdateOrgMemberLabelAssignmentsDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMemberLabelsControllerBatchUpdateAssignments<TData = void>(orgId: string,
    labelId: string,
    batchUpdateOrgMemberLabelAssignmentsDto: BatchUpdateOrgMemberLabelAssignmentsDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMemberLabelsControllerBatchUpdateAssignments<TData = void>(orgId: string,
    labelId: string,
    batchUpdateOrgMemberLabelAssignmentsDto: BatchUpdateOrgMemberLabelAssignmentsDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMemberLabelsControllerBatchUpdateAssignments<TData = void>(
    orgId: string,
    labelId: string,
    batchUpdateOrgMemberLabelAssignmentsDto: BatchUpdateOrgMemberLabelAssignmentsDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/member-labels/${labelId}/assignments/batch`,
      batchUpdateOrgMemberLabelAssignmentsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/member-labels/${labelId}/assignments/batch`,
      batchUpdateOrgMemberLabelAssignmentsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/member-labels/${labelId}/assignments/batch`,
      batchUpdateOrgMemberLabelAssignmentsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 커스텀 라벨 배정 해제 (org admin 전용)
 */
 spinoffOrgMemberLabelsControllerUnassign<TData = void>(orgId: string,
    labelId: string,
    targetId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMemberLabelsControllerUnassign<TData = void>(orgId: string,
    labelId: string,
    targetId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMemberLabelsControllerUnassign<TData = void>(orgId: string,
    labelId: string,
    targetId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMemberLabelsControllerUnassign<TData = void>(
    orgId: string,
    labelId: string,
    targetId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/member-labels/${labelId}/assignments/${targetId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/member-labels/${labelId}/assignments/${targetId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/orgs/${orgId}/member-labels/${labelId}/assignments/${targetId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 admin이 schoolbell-e 멤버 피커 세션(1회용 code)을 생성
 */
 memberPickerControllerCreateSession<TData = MemberPickerSessionCreatedDto>(orgId: string, options?: HttpClientBodyOptions): Observable<TData>;
 memberPickerControllerCreateSession<TData = MemberPickerSessionCreatedDto>(orgId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 memberPickerControllerCreateSession<TData = MemberPickerSessionCreatedDto>(orgId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  memberPickerControllerCreateSession<TData = MemberPickerSessionCreatedDto>(
    orgId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/member-picker/session`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/member-picker/session`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/member-picker/session`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * role/memberLabelId/contactAssignmentLabelId/contactLabelId로 명단을 좁힐 수 있다(같은 필드 안 여러 값은 OR, 서로 다른 필드끼리는 AND). userId/phone/email(2026-09-24, schoolbell-e-api parity)은 이 넷과는 별개로 서로 OR다(사람을 가리키는 방법이 여러 개일 뿐이라 — 예: userId나 phone 둘 중 하나만 맞아도 매칭). includeTeams=true면 team 소속 자리까지 포함하고, 생략하면 org 직속 자리만 반환한다. 특정 team으로 좁혀 보려면 GET /orgs/:orgId/teams/:teamId/members(team-members)를 별도로 쓴다.
 * @summary 단체 멤버 목록 (단체 구성원 — org role Owner·Admin·Member, 이름·전화번호 포함 명단, 기본 org 직속·includeTeams=true면 team 포함)
 */
 spinoffOrgMembersControllerListMembers<TData = ListOrgMembersResponseDto>(orgId: string,
    params?: SpinoffOrgMembersControllerListMembersParams, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMembersControllerListMembers<TData = ListOrgMembersResponseDto>(orgId: string,
    params?: SpinoffOrgMembersControllerListMembersParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMembersControllerListMembers<TData = ListOrgMembersResponseDto>(orgId: string,
    params?: SpinoffOrgMembersControllerListMembersParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMembersControllerListMembers<TData = ListOrgMembersResponseDto>(
    orgId: string,
    params?: SpinoffOrgMembersControllerListMembersParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/members`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/members`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/members`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * inviteMember와 동일하게 Pending 초대장을 만든다. email/phone이 이미 가입된 User와 매칭되면 수락 절차 없이 즉시 활성 멤버가 된다(응답의 contacts[0].isActive로 확인). 아직 가입하지 않은 대상은 Pending으로 남아, 나중에 그 email/phone으로 가입한 사람이 직접 수락해야 한다. recordOnly=true면 이 자동매칭·초대장 생성을 전부 건너뛴다(AddOrgMemberBodyDto.recordOnly 참고).
 * @summary 단체 멤버 단건 추가 (수락 대기 초대장 생성 — 이미 가입된 유저면 자동 수락)
 */
 spinoffOrgMembersControllerCreateMember<TData = OrgMemberDto>(orgId: string,
    addOrgMemberBodyDto: AddOrgMemberBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMembersControllerCreateMember<TData = OrgMemberDto>(orgId: string,
    addOrgMemberBodyDto: AddOrgMemberBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMembersControllerCreateMember<TData = OrgMemberDto>(orgId: string,
    addOrgMemberBodyDto: AddOrgMemberBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMembersControllerCreateMember<TData = OrgMemberDto>(
    orgId: string,
    addOrgMemberBodyDto: AddOrgMemberBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/members`,
      addOrgMemberBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/members`,
      addOrgMemberBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/members`,
      addOrgMemberBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * teamId를 생략하면 org 직속 멤버, 지정하면 그 team 멤버가 대상 스코프다. operations에 담긴 항목만 처리되고, 이 스코프의 다른 기존 멤버는 그대로 유지된다(schoolbell-e-api org-members.service.ts #batchWriteMembers와 동일한 explicit-op 계약). create 항목은 addMember와 동일하게 Pending 초대장으로 생성되며, 이미 가입된 유저와 매칭되면 자동 수락된다. **Member 자리만 다룬다** — Owner/Admin 자리를 만들거나(create의 role), 바꾸거나(update의 role), 지우는(delete 대상) 항목은 400이다. Owner/Admin 지정·해제는 멤버 단건 쓰기로 한다(단체 Owner만 가능, 권한 규칙 문서 참고).
 * @summary 단체 멤버 다수 변경 (operations에 담긴 오퍼레이션만 처리 — 명시적 create/update/delete)
 */
 spinoffOrgMembersControllerBatchWriteMembers<TData = BatchOrgMembersResultDto>(orgId: string,
    batchOrgMembersBodyDto: BatchOrgMembersBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMembersControllerBatchWriteMembers<TData = BatchOrgMembersResultDto>(orgId: string,
    batchOrgMembersBodyDto: BatchOrgMembersBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMembersControllerBatchWriteMembers<TData = BatchOrgMembersResultDto>(orgId: string,
    batchOrgMembersBodyDto: BatchOrgMembersBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMembersControllerBatchWriteMembers<TData = BatchOrgMembersResultDto>(
    orgId: string,
    batchOrgMembersBodyDto: BatchOrgMembersBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/members/batch`,
      batchOrgMembersBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/members/batch`,
      batchOrgMembersBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/members/batch`,
      batchOrgMembersBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 멤버 단건 삭제
 */
 spinoffOrgMembersControllerDeleteMember<TData = void>(orgId: string,
    memberId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMembersControllerDeleteMember<TData = void>(orgId: string,
    memberId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMembersControllerDeleteMember<TData = void>(orgId: string,
    memberId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMembersControllerDeleteMember<TData = void>(
    orgId: string,
    memberId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/members/${memberId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/members/${memberId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/orgs/${orgId}/members/${memberId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 바꿀 필드만 보낸다(`name`·`teamId`의 `null`은 각각 이름 지움·단체 직속으로). 변경 전 자리는 서버가 대상을 읽어 채우고, 판정과 쓰기 사이에 대상이 바뀌면 409(다시 시도)다. 건드리는 자리(변경 전·후)마다 규칙을 만족해야 한다 — 단체 직속 Admin·Owner로 올리거나 내리는 것은 단체 Owner만 할 수 있다(규칙 2). 단체↔팀 이동은 불가하고 팀→팀 이동은 Member만 가능하다. 연락처 수정은 patch 모양 정렬 뒤에 더한다. 변경할 필드가 하나도 없으면 400.
 * @summary 단체 멤버 수정 —역할·팀 이동·이름 (단체 admin 전용, 역할·위치 변경 가능 여부는 권한 규칙으로 판정)
 */
 spinoffOrgMembersControllerUpdateMember<TData = OrgMemberDto>(orgId: string,
    memberId: string,
    updateOrgMemberBodyDto: UpdateOrgMemberBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMembersControllerUpdateMember<TData = OrgMemberDto>(orgId: string,
    memberId: string,
    updateOrgMemberBodyDto: UpdateOrgMemberBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMembersControllerUpdateMember<TData = OrgMemberDto>(orgId: string,
    memberId: string,
    updateOrgMemberBodyDto: UpdateOrgMemberBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMembersControllerUpdateMember<TData = OrgMemberDto>(
    orgId: string,
    memberId: string,
    updateOrgMemberBodyDto: UpdateOrgMemberBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/members/${memberId}`,
      updateOrgMemberBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/members/${memberId}`,
      updateOrgMemberBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/orgs/${orgId}/members/${memberId}`,
      updateOrgMemberBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * "이전 자리 X(sameAsMemberId) = 새 자리(:memberId), 동일인"을 사람이 확인해 연결한다. sameAsMemberId를 생략하면 새 연속성을 만든다(전입생 등). 이미 연속성이 있는 자리를 다시 호출하면 그 값이 덮어써진다 — 오연결 정정도 이 하나의 엔드포인트가 담당한다. sameAsMemberId가 다른 단체 소속이거나 없는 자리면 404(cross-org 연결은 v1에서 차단), 대상 자리와 같으면 400이다. 삭제된 자리를 sameAsMemberId로 줄 수 있다.
 * @summary 자리 다년 연속성 수동 연결/재연결 (org admin 세션 전용, RP 토큰 미지원)
 */
 spinoffOrgMemberContinuityControllerCreateLink<TData = ContinuityLinkDto>(orgId: string,
    memberId: string,
    createContinuityLinkBodyDto: CreateContinuityLinkBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMemberContinuityControllerCreateLink<TData = ContinuityLinkDto>(orgId: string,
    memberId: string,
    createContinuityLinkBodyDto: CreateContinuityLinkBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMemberContinuityControllerCreateLink<TData = ContinuityLinkDto>(orgId: string,
    memberId: string,
    createContinuityLinkBodyDto: CreateContinuityLinkBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMemberContinuityControllerCreateLink<TData = ContinuityLinkDto>(
    orgId: string,
    memberId: string,
    createContinuityLinkBodyDto: CreateContinuityLinkBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/members/${memberId}/continuity-links`,
      createContinuityLinkBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/members/${memberId}/continuity-links`,
      createContinuityLinkBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/members/${memberId}/continuity-links`,
      createContinuityLinkBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 단체(Owner·Admin)가 소유 계정 자리의 로그인 코드를 새로 발급한다 — **재발급이 폐기를 겸한다**(자리당 활성 코드는 하나이고 이전 코드는 즉시 쓸 수 없다). 계정·권한은 그대로이고 코드만 바뀐다. 응답의 `login.code`는 이 응답에서 한 번만 볼 수 있다. 소유 계정이 아닌 자리는 404다. 코드를 아예 막으려면 자리를 삭제한다.
 * @summary 단체 소유 멤버의 로그인 코드 재발급 (이전 코드는 즉시 폐기)
 */
 spinoffOrgMembersControllerReissueManagedCredential<TData = ReissuedManagedCredentialDto>(orgId: string,
    memberId: string,
    reissueManagedCredentialBodyDto: ReissueManagedCredentialBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMembersControllerReissueManagedCredential<TData = ReissuedManagedCredentialDto>(orgId: string,
    memberId: string,
    reissueManagedCredentialBodyDto: ReissueManagedCredentialBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMembersControllerReissueManagedCredential<TData = ReissuedManagedCredentialDto>(orgId: string,
    memberId: string,
    reissueManagedCredentialBodyDto: ReissueManagedCredentialBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMembersControllerReissueManagedCredential<TData = ReissuedManagedCredentialDto>(
    orgId: string,
    memberId: string,
    reissueManagedCredentialBodyDto: ReissueManagedCredentialBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/members/${memberId}/managed-credential`,
      reissueManagedCredentialBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/members/${memberId}/managed-credential`,
      reissueManagedCredentialBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/members/${memberId}/managed-credential`,
      reissueManagedCredentialBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 같은 레벨(같은 팀·같은 역할)의 자리끼리만 바꾼다 — afterMemberId 바로 뒤로 옮기고, 생략/null이면 그 레벨의 맨 앞. 단체 Admin은 단체 Admin·Owner의 순서를 바꿀 수 없다. 2026-08-19부터 다른 버저닝 리소스와 동일하게 새 version+감사로그(action=MemberUpdated)를 남긴다.
 * @summary 단체 멤버 표시 순서 재배치 (드래그 재정렬)
 */
 spinoffOrgMembersControllerUpdateMemberSortKey<TData = void>(orgId: string,
    memberId: string,
    updateMemberSortKeyBodyDto: UpdateMemberSortKeyBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgMembersControllerUpdateMemberSortKey<TData = void>(orgId: string,
    memberId: string,
    updateMemberSortKeyBodyDto: UpdateMemberSortKeyBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgMembersControllerUpdateMemberSortKey<TData = void>(orgId: string,
    memberId: string,
    updateMemberSortKeyBodyDto: UpdateMemberSortKeyBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgMembersControllerUpdateMemberSortKey<TData = void>(
    orgId: string,
    memberId: string,
    updateMemberSortKeyBodyDto: UpdateMemberSortKeyBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/members/${memberId}/sort-key`,
      updateMemberSortKeyBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/members/${memberId}/sort-key`,
      updateMemberSortKeyBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/orgs/${orgId}/members/${memberId}/sort-key`,
      updateMemberSortKeyBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체의 message 목록 (org 소속 전 멤버가 보낸 메시지, cursor 페이지네이션)
 */
 orgMessagesControllerList<TData = ListMessagesResponseDto>(orgId: unknown,
    params?: OrgMessagesControllerListParams, options?: HttpClientBodyOptions): Observable<TData>;
 orgMessagesControllerList<TData = ListMessagesResponseDto>(orgId: unknown,
    params?: OrgMessagesControllerListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMessagesControllerList<TData = ListMessagesResponseDto>(orgId: unknown,
    params?: OrgMessagesControllerListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMessagesControllerList<TData = ListMessagesResponseDto>(
    orgId: unknown,
    params?: OrgMessagesControllerListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/messages`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/messages`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/messages`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 단체 컨텍스트 SMS 발송 요청 enqueue
 */
 orgMessagesControllerCreate<TData = CreatedMessageResponseDto>(orgId: unknown,
    createMessageBodyDto: CreateMessageBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgMessagesControllerCreate<TData = CreatedMessageResponseDto>(orgId: unknown,
    createMessageBodyDto: CreateMessageBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMessagesControllerCreate<TData = CreatedMessageResponseDto>(orgId: unknown,
    createMessageBodyDto: CreateMessageBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMessagesControllerCreate<TData = CreatedMessageResponseDto>(
    orgId: unknown,
    createMessageBodyDto: CreateMessageBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/messages`,
      createMessageBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/messages`,
      createMessageBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/messages`,
      createMessageBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 예약 발송 취소 — 본인이 이 org에서 보낸 메시지만
 */
 orgMessagesControllerCancel<TData = void>(orgId: unknown,
    id: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgMessagesControllerCancel<TData = void>(orgId: unknown,
    id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMessagesControllerCancel<TData = void>(orgId: unknown,
    id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMessagesControllerCancel<TData = void>(
    orgId: unknown,
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/messages/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/messages/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/orgs/${orgId}/messages/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 message 단건 (같은 org 누구든 조회 가능)
 */
 orgMessagesControllerGetById<TData = MessageDetailDto>(orgId: unknown,
    id: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgMessagesControllerGetById<TData = MessageDetailDto>(orgId: unknown,
    id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMessagesControllerGetById<TData = MessageDetailDto>(orgId: unknown,
    id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMessagesControllerGetById<TData = MessageDetailDto>(
    orgId: unknown,
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/messages/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/messages/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/messages/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary message.blind 토글 — 본인이 이 org에서 보낸 메시지만
 */
 orgMessagesControllerUpdate<TData = MessageDetailDto>(orgId: unknown,
    id: string,
    updateMessageBodyDto: UpdateMessageBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgMessagesControllerUpdate<TData = MessageDetailDto>(orgId: unknown,
    id: string,
    updateMessageBodyDto: UpdateMessageBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMessagesControllerUpdate<TData = MessageDetailDto>(orgId: unknown,
    id: string,
    updateMessageBodyDto: UpdateMessageBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMessagesControllerUpdate<TData = MessageDetailDto>(
    orgId: unknown,
    id: string,
    updateMessageBodyDto: UpdateMessageBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/messages/${id}`,
      updateMessageBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/messages/${id}`,
      updateMessageBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/orgs/${orgId}/messages/${id}`,
      updateMessageBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 message의 수신자별 delivery 목록
 */
 orgMessagesControllerListDetails<TData = ListMessageDetailsResponseDto>(orgId: unknown,
    id: string,
    params?: OrgMessagesControllerListDetailsParams, options?: HttpClientBodyOptions): Observable<TData>;
 orgMessagesControllerListDetails<TData = ListMessageDetailsResponseDto>(orgId: unknown,
    id: string,
    params?: OrgMessagesControllerListDetailsParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgMessagesControllerListDetails<TData = ListMessageDetailsResponseDto>(orgId: unknown,
    id: string,
    params?: OrgMessagesControllerListDetailsParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgMessagesControllerListDetails<TData = ListMessageDetailsResponseDto>(
    orgId: unknown,
    id: string,
    params?: OrgMessagesControllerListDetailsParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/messages/${id}/details`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/messages/${id}/details`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/messages/${id}/details`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 단체 컨텍스트 발신번호 목록
 */
 orgOriginatorsControllerList<TData = ListOriginatorsResponseDto>(orgId: unknown,
    params?: OrgOriginatorsControllerListParams, options?: HttpClientBodyOptions): Observable<TData>;
 orgOriginatorsControllerList<TData = ListOriginatorsResponseDto>(orgId: unknown,
    params?: OrgOriginatorsControllerListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgOriginatorsControllerList<TData = ListOriginatorsResponseDto>(orgId: unknown,
    params?: OrgOriginatorsControllerListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgOriginatorsControllerList<TData = ListOriginatorsResponseDto>(
    orgId: unknown,
    params?: OrgOriginatorsControllerListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/originators`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/originators`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/originators`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * 발송사별 인증 흐름은 본 PR 범위 밖 — 등록 시점에는 항상 isVerified=false.
 * @summary 단체 컨텍스트 발신번호 등록 (isVerified=false)
 */
 orgOriginatorsControllerCreate<TData = OriginatorDto>(orgId: unknown,
    createOriginatorBodyDto: CreateOriginatorBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgOriginatorsControllerCreate<TData = OriginatorDto>(orgId: unknown,
    createOriginatorBodyDto: CreateOriginatorBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgOriginatorsControllerCreate<TData = OriginatorDto>(orgId: unknown,
    createOriginatorBodyDto: CreateOriginatorBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgOriginatorsControllerCreate<TData = OriginatorDto>(
    orgId: unknown,
    createOriginatorBodyDto: CreateOriginatorBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/originators`,
      createOriginatorBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/originators`,
      createOriginatorBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/originators`,
      createOriginatorBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 컨텍스트 서류 업로드용 GCS Signed URL 발급
 */
 orgOriginatorsControllerGetUploadUrl<TData = UploadUrlResponseDto>(orgId: unknown,
    uploadUrlBodyDto: UploadUrlBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgOriginatorsControllerGetUploadUrl<TData = UploadUrlResponseDto>(orgId: unknown,
    uploadUrlBodyDto: UploadUrlBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgOriginatorsControllerGetUploadUrl<TData = UploadUrlResponseDto>(orgId: unknown,
    uploadUrlBodyDto: UploadUrlBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgOriginatorsControllerGetUploadUrl<TData = UploadUrlResponseDto>(
    orgId: unknown,
    uploadUrlBodyDto: UploadUrlBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/originators/documents/upload-url`,
      uploadUrlBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/originators/documents/upload-url`,
      uploadUrlBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/originators/documents/upload-url`,
      uploadUrlBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 컨텍스트 업로드 완료 후 단체 사업자등록증 File 등록 (D7)
 */
 orgOriginatorsControllerRegisterOrgDocument<TData = RegisterOrgDocumentResponseDto>(orgId: unknown,
    registerOrgDocumentBodyDto: RegisterOrgDocumentBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgOriginatorsControllerRegisterOrgDocument<TData = RegisterOrgDocumentResponseDto>(orgId: unknown,
    registerOrgDocumentBodyDto: RegisterOrgDocumentBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgOriginatorsControllerRegisterOrgDocument<TData = RegisterOrgDocumentResponseDto>(orgId: unknown,
    registerOrgDocumentBodyDto: RegisterOrgDocumentBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgOriginatorsControllerRegisterOrgDocument<TData = RegisterOrgDocumentResponseDto>(
    orgId: unknown,
    registerOrgDocumentBodyDto: RegisterOrgDocumentBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/originators/org-documents`,
      registerOrgDocumentBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/originators/org-documents`,
      registerOrgDocumentBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/originators/org-documents`,
      registerOrgDocumentBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 사업자등록증 업로드용 GCS Signed URL 발급 (D7)
 */
 orgOriginatorsControllerGetOrgDocumentUploadUrl<TData = OrgDocumentUploadUrlResponseDto>(orgId: unknown,
    orgDocumentUploadUrlBodyDto: OrgDocumentUploadUrlBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgOriginatorsControllerGetOrgDocumentUploadUrl<TData = OrgDocumentUploadUrlResponseDto>(orgId: unknown,
    orgDocumentUploadUrlBodyDto: OrgDocumentUploadUrlBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgOriginatorsControllerGetOrgDocumentUploadUrl<TData = OrgDocumentUploadUrlResponseDto>(orgId: unknown,
    orgDocumentUploadUrlBodyDto: OrgDocumentUploadUrlBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgOriginatorsControllerGetOrgDocumentUploadUrl<TData = OrgDocumentUploadUrlResponseDto>(
    orgId: unknown,
    orgDocumentUploadUrlBodyDto: OrgDocumentUploadUrlBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/originators/org-documents/upload-url`,
      orgDocumentUploadUrlBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/originators/org-documents/upload-url`,
      orgDocumentUploadUrlBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/originators/org-documents/upload-url`,
      orgDocumentUploadUrlBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 컨텍스트 재사용 가능한 서류 파일 목록
 */
 orgOriginatorsControllerListReusableDocuments<TData = ReusableDocumentsResponseDto>(orgId: unknown,
    params?: OrgOriginatorsControllerListReusableDocumentsParams, options?: HttpClientBodyOptions): Observable<TData>;
 orgOriginatorsControllerListReusableDocuments<TData = ReusableDocumentsResponseDto>(orgId: unknown,
    params?: OrgOriginatorsControllerListReusableDocumentsParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgOriginatorsControllerListReusableDocuments<TData = ReusableDocumentsResponseDto>(orgId: unknown,
    params?: OrgOriginatorsControllerListReusableDocumentsParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgOriginatorsControllerListReusableDocuments<TData = ReusableDocumentsResponseDto>(
    orgId: unknown,
    params?: OrgOriginatorsControllerListReusableDocumentsParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/originators/reusable-documents`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/originators/reusable-documents`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/originators/reusable-documents`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 단체 컨텍스트 소프트 삭제 (deletedAt = now())
 */
 orgOriginatorsControllerRemove<TData = void>(orgId: unknown,
    id: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgOriginatorsControllerRemove<TData = void>(orgId: unknown,
    id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgOriginatorsControllerRemove<TData = void>(orgId: unknown,
    id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgOriginatorsControllerRemove<TData = void>(
    orgId: unknown,
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/originators/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/originators/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/orgs/${orgId}/originators/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 컨텍스트 발신번호 단건
 */
 orgOriginatorsControllerGetById<TData = OriginatorDto>(orgId: unknown,
    id: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgOriginatorsControllerGetById<TData = OriginatorDto>(orgId: unknown,
    id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgOriginatorsControllerGetById<TData = OriginatorDto>(orgId: unknown,
    id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgOriginatorsControllerGetById<TData = OriginatorDto>(
    orgId: unknown,
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/originators/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/originators/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/originators/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * isVerified 와 phoneNumber 는 PATCH 로 변경 불가.
 * @summary 단체 컨텍스트 발신번호 부분 수정 (shared/comment/lexorank)
 */
 orgOriginatorsControllerUpdate<TData = OriginatorDto>(orgId: unknown,
    id: string,
    updateOriginatorBodyDto: UpdateOriginatorBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgOriginatorsControllerUpdate<TData = OriginatorDto>(orgId: unknown,
    id: string,
    updateOriginatorBodyDto: UpdateOriginatorBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgOriginatorsControllerUpdate<TData = OriginatorDto>(orgId: unknown,
    id: string,
    updateOriginatorBodyDto: UpdateOriginatorBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgOriginatorsControllerUpdate<TData = OriginatorDto>(
    orgId: unknown,
    id: string,
    updateOriginatorBodyDto: UpdateOriginatorBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/originators/${id}`,
      updateOriginatorBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/originators/${id}`,
      updateOriginatorBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/orgs/${orgId}/originators/${id}`,
      updateOriginatorBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 컨텍스트 발신번호에 첨부된 서류 목록
 */
 orgOriginatorsControllerListDocuments<TData = ListOriginatorDocumentsResponseDto>(orgId: unknown,
    id: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgOriginatorsControllerListDocuments<TData = ListOriginatorDocumentsResponseDto>(orgId: unknown,
    id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgOriginatorsControllerListDocuments<TData = ListOriginatorDocumentsResponseDto>(orgId: unknown,
    id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgOriginatorsControllerListDocuments<TData = ListOriginatorDocumentsResponseDto>(
    orgId: unknown,
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/originators/${id}/documents`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/originators/${id}/documents`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/originators/${id}/documents`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 민감 서류이므로 CDN 미경유. 같은 org 스코프의 파일만 접근 가능.
 * @summary 단체 컨텍스트 서류 파일 Signed GET URL 발급 (15분 유효)
 */
 orgOriginatorsControllerGetDocumentDownloadUrl<TData = OriginatorDocumentDownloadUrlDto>(orgId: unknown,
    id: string,
    fileId: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgOriginatorsControllerGetDocumentDownloadUrl<TData = OriginatorDocumentDownloadUrlDto>(orgId: unknown,
    id: string,
    fileId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgOriginatorsControllerGetDocumentDownloadUrl<TData = OriginatorDocumentDownloadUrlDto>(orgId: unknown,
    id: string,
    fileId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgOriginatorsControllerGetDocumentDownloadUrl<TData = OriginatorDocumentDownloadUrlDto>(
    orgId: unknown,
    id: string,
    fileId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/originators/${id}/documents/${fileId}/download-url`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/originators/${id}/documents/${fileId}/download-url`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/originators/${id}/documents/${fileId}/download-url`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 이미 자리(seat)가 있는 멤버에게 직접 scope 부여(anchoring 불필요)
 */
 orgPermissionGrantControllerGrantToMember<TData = OrgPermissionGrantResultDto>(orgId: string,
    memberId: string,
    grantOrgPermissionToMemberDto: GrantOrgPermissionToMemberDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgPermissionGrantControllerGrantToMember<TData = OrgPermissionGrantResultDto>(orgId: string,
    memberId: string,
    grantOrgPermissionToMemberDto: GrantOrgPermissionToMemberDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgPermissionGrantControllerGrantToMember<TData = OrgPermissionGrantResultDto>(orgId: string,
    memberId: string,
    grantOrgPermissionToMemberDto: GrantOrgPermissionToMemberDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgPermissionGrantControllerGrantToMember<TData = OrgPermissionGrantResultDto>(
    orgId: string,
    memberId: string,
    grantOrgPermissionToMemberDto: GrantOrgPermissionToMemberDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/permission-grants/member/${memberId}`,
      grantOrgPermissionToMemberDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/permission-grants/member/${memberId}`,
      grantOrgPermissionToMemberDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/permission-grants/member/${memberId}`,
      grantOrgPermissionToMemberDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 로컬 seat 없는 schoolbell-e 라이브 member id에 부여된 scope 목록 조회
 */
 orgPermissionGrantControllerListProviderMemberScopes<TData = OrgPermissionScopesResponseDto>(orgId: string,
    rawMemberId: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgPermissionGrantControllerListProviderMemberScopes<TData = OrgPermissionScopesResponseDto>(orgId: string,
    rawMemberId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgPermissionGrantControllerListProviderMemberScopes<TData = OrgPermissionScopesResponseDto>(orgId: string,
    rawMemberId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgPermissionGrantControllerListProviderMemberScopes<TData = OrgPermissionScopesResponseDto>(
    orgId: string,
    rawMemberId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/permission-grants/provider-member/${rawMemberId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/permission-grants/provider-member/${rawMemberId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/permission-grants/provider-member/${rawMemberId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 로컬 seat 없는 schoolbell-e 라이브 member id에 직접 scope 부여
 */
 orgPermissionGrantControllerGrantToProviderMember<TData = OrgPermissionGrantResultDto>(orgId: string,
    rawMemberId: string,
    grantOrgPermissionToMemberDto: GrantOrgPermissionToMemberDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgPermissionGrantControllerGrantToProviderMember<TData = OrgPermissionGrantResultDto>(orgId: string,
    rawMemberId: string,
    grantOrgPermissionToMemberDto: GrantOrgPermissionToMemberDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgPermissionGrantControllerGrantToProviderMember<TData = OrgPermissionGrantResultDto>(orgId: string,
    rawMemberId: string,
    grantOrgPermissionToMemberDto: GrantOrgPermissionToMemberDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgPermissionGrantControllerGrantToProviderMember<TData = OrgPermissionGrantResultDto>(
    orgId: string,
    rawMemberId: string,
    grantOrgPermissionToMemberDto: GrantOrgPermissionToMemberDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/permission-grants/provider-member/${rawMemberId}`,
      grantOrgPermissionToMemberDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/permission-grants/provider-member/${rawMemberId}`,
      grantOrgPermissionToMemberDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/permission-grants/provider-member/${rawMemberId}`,
      grantOrgPermissionToMemberDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 로컬 seat 없는 schoolbell-e 라이브 member id에서 scope 회수
 */
 orgPermissionGrantControllerRevokeFromProviderMember<TData = void>(orgId: string,
    rawMemberId: string,
    scope: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgPermissionGrantControllerRevokeFromProviderMember<TData = void>(orgId: string,
    rawMemberId: string,
    scope: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgPermissionGrantControllerRevokeFromProviderMember<TData = void>(orgId: string,
    rawMemberId: string,
    scope: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgPermissionGrantControllerRevokeFromProviderMember<TData = void>(
    orgId: string,
    rawMemberId: string,
    scope: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/permission-grants/provider-member/${rawMemberId}/${scope}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/permission-grants/provider-member/${rawMemberId}/${scope}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/orgs/${orgId}/permission-grants/provider-member/${rawMemberId}/${scope}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 권한 부여 현황 조회 (org admin 전용)
 */
 spinoffOrgPermissionsControllerList<TData = OrgPermissionListResponseDto>(orgId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgPermissionsControllerList<TData = OrgPermissionListResponseDto>(orgId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgPermissionsControllerList<TData = OrgPermissionListResponseDto>(orgId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgPermissionsControllerList<TData = OrgPermissionListResponseDto>(
    orgId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/permissions`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/permissions`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/permissions`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 권한 부여 (org admin 전용) — memberId/labelId/targetRefKey 중 정확히 하나
 */
 spinoffOrgPermissionsControllerGrant<TData = OrgPermissionDto>(orgId: string,
    grantOrgPermissionDto: GrantOrgPermissionDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgPermissionsControllerGrant<TData = OrgPermissionDto>(orgId: string,
    grantOrgPermissionDto: GrantOrgPermissionDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgPermissionsControllerGrant<TData = OrgPermissionDto>(orgId: string,
    grantOrgPermissionDto: GrantOrgPermissionDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgPermissionsControllerGrant<TData = OrgPermissionDto>(
    orgId: string,
    grantOrgPermissionDto: GrantOrgPermissionDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/permissions`,
      grantOrgPermissionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/permissions`,
      grantOrgPermissionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/permissions`,
      grantOrgPermissionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 권한 회수 (org admin 전용)
 */
 spinoffOrgPermissionsControllerRevoke<TData = void>(orgId: string,
    permissionId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgPermissionsControllerRevoke<TData = void>(orgId: string,
    permissionId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgPermissionsControllerRevoke<TData = void>(orgId: string,
    permissionId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgPermissionsControllerRevoke<TData = void>(
    orgId: string,
    permissionId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/permissions/${permissionId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/permissions/${permissionId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/orgs/${orgId}/permissions/${permissionId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * SPA가 인증된 fetch로 호출해 URL을 받고 직접 window.location으로 이동한다(302 아님 — 브라우저 GET 네비게이션은 Authorization 헤더를 실어보낼 수 없다).
 * @summary 학교종이 단체 연결 authorize URL 발급
 */
 schoolbellOrgLinkControllerAuthorizeRedirect<TData = SchoolbellOrgLinkAuthorizeUrlDto>(orgId: string, options?: HttpClientBodyOptions): Observable<TData>;
 schoolbellOrgLinkControllerAuthorizeRedirect<TData = SchoolbellOrgLinkAuthorizeUrlDto>(orgId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 schoolbellOrgLinkControllerAuthorizeRedirect<TData = SchoolbellOrgLinkAuthorizeUrlDto>(orgId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  schoolbellOrgLinkControllerAuthorizeRedirect<TData = SchoolbellOrgLinkAuthorizeUrlDto>(
    orgId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/schoolbell-link/authorize-redirect`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/schoolbell-link/authorize-redirect`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/schoolbell-link/authorize-redirect`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 이 앱이 연결 시 요구하는 권한(org.*)과 단체가 실제로 동의한 권한을 비교한다. 연동 이후 추가된 권한은 refresh_token으로 넓힐 수 없어(RFC 6749) 재동의가 필요하다. 동의 기록이 없는 옛 연결은 reconsentRequired=false(확인 불가).
 * @summary 학교종이 권한 동의 상태 — 재동의(권한 갱신) 필요 여부
 */
 schoolbellOrgLinkControllerScopeStatus<TData = SchoolbellOrgLinkScopeStatusDto>(orgId: string, options?: HttpClientBodyOptions): Observable<TData>;
 schoolbellOrgLinkControllerScopeStatus<TData = SchoolbellOrgLinkScopeStatusDto>(orgId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 schoolbellOrgLinkControllerScopeStatus<TData = SchoolbellOrgLinkScopeStatusDto>(orgId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  schoolbellOrgLinkControllerScopeStatus<TData = SchoolbellOrgLinkScopeStatusDto>(
    orgId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/schoolbell-link/scope-status`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/schoolbell-link/scope-status`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/schoolbell-link/scope-status`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 팀(반) 목록 (단체 구성원 — org role Owner·Admin·Member)
 */
 spinoffOrgTeamsControllerListTeams<TData = ListOrgTeamsResponseDto>(orgId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgTeamsControllerListTeams<TData = ListOrgTeamsResponseDto>(orgId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgTeamsControllerListTeams<TData = ListOrgTeamsResponseDto>(orgId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgTeamsControllerListTeams<TData = ListOrgTeamsResponseDto>(
    orgId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/teams`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 팀 생성 (org admin 전용)
 */
 spinoffOrgTeamsControllerCreateTeam<TData = OrgTeamDto>(orgId: string,
    createOrgTeamBodyDto: CreateOrgTeamBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgTeamsControllerCreateTeam<TData = OrgTeamDto>(orgId: string,
    createOrgTeamBodyDto: CreateOrgTeamBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgTeamsControllerCreateTeam<TData = OrgTeamDto>(orgId: string,
    createOrgTeamBodyDto: CreateOrgTeamBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgTeamsControllerCreateTeam<TData = OrgTeamDto>(
    orgId: string,
    createOrgTeamBodyDto: CreateOrgTeamBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/teams`,
      createOrgTeamBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/teams`,
      createOrgTeamBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/teams`,
      createOrgTeamBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 개별 라우트(POST/PATCH/DELETE)를 대체하지 않고 추가된 경로다(schoolbell-e `POST /orgs/:orgId/teams/batch`와 같은 모양, 2026-10-06 HTTP 정렬). 인가는 개별 라우트와 같다 — 배치도 그 조작들의 합이라 더 느슨하게 열지 않는다. 전체가 한 트랜잭션이라 중간 실패 시 모두 롤백된다.
 * @summary 팀(반) 생성/이름변경/삭제/이동 배치 처리 (org admin 전용)
 */
 spinoffOrgTeamsControllerBatchWriteTeams<TData = ListOrgTeamsResponseDto>(orgId: string,
    batchOrgTeamsBodyDto: BatchOrgTeamsBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgTeamsControllerBatchWriteTeams<TData = ListOrgTeamsResponseDto>(orgId: string,
    batchOrgTeamsBodyDto: BatchOrgTeamsBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgTeamsControllerBatchWriteTeams<TData = ListOrgTeamsResponseDto>(orgId: string,
    batchOrgTeamsBodyDto: BatchOrgTeamsBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgTeamsControllerBatchWriteTeams<TData = ListOrgTeamsResponseDto>(
    orgId: string,
    batchOrgTeamsBodyDto: BatchOrgTeamsBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/teams/batch`,
      batchOrgTeamsBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/teams/batch`,
      batchOrgTeamsBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/teams/batch`,
      batchOrgTeamsBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 재배치가 아니라 실제 제거다(팀+멤버 모두 soft-close). 연동 단체의 외부 팀(예: `schoolbell-e:...`)을 지정하면 읽기 전용이라 403이다.
 * @summary 팀 삭제 (org admin 전용) — 서브트리(자신+하위 team) 전체와 그 소속 멤버가 함께 삭제된다
 */
 spinoffOrgTeamsControllerDeleteTeam<TData = void>(orgId: string,
    teamId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgTeamsControllerDeleteTeam<TData = void>(orgId: string,
    teamId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgTeamsControllerDeleteTeam<TData = void>(orgId: string,
    teamId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgTeamsControllerDeleteTeam<TData = void>(
    orgId: string,
    teamId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/teams/${teamId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/teams/${teamId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/orgs/${orgId}/teams/${teamId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 응답은 팀 이름·계층(parent/children)뿐이고 명단은 싣지 않는다 — 명단은 `GET :teamId/members`가 team owner/admin으로만 연다(2026-10-06, schoolbell-e `getTeam`과 같은 범위). 다른 팀 구성원은 403이다(상위 팀 소속 상속 없음).
 * @summary 팀(반) 단건 조회 — 팀 뷰용 (org admin 또는 이 팀의 구성원)
 */
 spinoffOrgTeamsControllerGetTeam<TData = OrgTeamDetailDto>(orgId: string,
    teamId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgTeamsControllerGetTeam<TData = OrgTeamDetailDto>(orgId: string,
    teamId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgTeamsControllerGetTeam<TData = OrgTeamDetailDto>(orgId: string,
    teamId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgTeamsControllerGetTeam<TData = OrgTeamDetailDto>(
    orgId: string,
    teamId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * org Admin/Owner 또는 이 teamId에서 role이 Owner/Admin인 사람 중 하나만 통과해도 허용한다 (2026-08-19, schoolbell-e teamAdminAccessGuard와 완전히 정렬).
 * @summary 팀 이름 변경 (org admin 또는 이 팀의 owner/admin) — 소속(parent) 변경은 이 라우트로 못 한다, PATCH :teamId/parent 참고
 */
 spinoffOrgTeamsControllerRenameTeam<TData = OrgTeamDto>(orgId: string,
    teamId: string,
    renameOrgTeamBodyDto: RenameOrgTeamBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgTeamsControllerRenameTeam<TData = OrgTeamDto>(orgId: string,
    teamId: string,
    renameOrgTeamBodyDto: RenameOrgTeamBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgTeamsControllerRenameTeam<TData = OrgTeamDto>(orgId: string,
    teamId: string,
    renameOrgTeamBodyDto: RenameOrgTeamBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgTeamsControllerRenameTeam<TData = OrgTeamDto>(
    orgId: string,
    teamId: string,
    renameOrgTeamBodyDto: RenameOrgTeamBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/teams/${teamId}`,
      renameOrgTeamBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/teams/${teamId}`,
      renameOrgTeamBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/orgs/${orgId}/teams/${teamId}`,
      renameOrgTeamBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 이 team의 Owner/Admin 자리만 Owner → Admin 순으로, 같은 역할 안에서는 자리 생성 순서(오래된 것 먼저)로 돌려준다. Member 자리는 포함하지 않는다(2026-10-06, schoolbell-e `GET :teamId/admins`와 같은 모양).
 * @summary 팀 Owner·Admin 목록 (org admin 또는 이 팀의 Owner/Admin)
 */
 spinoffOrgTeamsControllerListTeamAdmins<TData = ListTeamAdminsResponseDto>(orgId: string,
    teamId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgTeamsControllerListTeamAdmins<TData = ListTeamAdminsResponseDto>(orgId: string,
    teamId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgTeamsControllerListTeamAdmins<TData = ListTeamAdminsResponseDto>(orgId: string,
    teamId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgTeamsControllerListTeamAdmins<TData = ListTeamAdminsResponseDto>(
    orgId: string,
    teamId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/admins`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/admins`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/admins`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 단체 구성원(org role Owner·Admin·Member) 또는 이 teamId **또는 그 상위 team**에서 role이 Owner/Admin인 사람만 볼 수 있다(상위 team Owner/Admin은 하위 team id를 직접 지정해도 된다, `anyOf(orgRole(Member+),teamRole(Admin+,inherit))`). includeDescendants를 생략하거나 false면 이 teamId에 직속된 멤버만 반환한다(schoolbell-e org-teams.service.ts#listTeamMembers와 동일하게 depth별로 분리 — 재귀 없음이 기본). includeDescendants:true면 OrgTeam.parentPath 기준 하위 team 전체를 포함한다. role(반복 가능, OR)과 labelId(반복 가능, 어느 레벨이든 하나라도 걸리면 통과 — OR)는 서로 AND다(schoolbell-e와 같은 쿼리 모양).
 * @summary 단체 team 멤버 목록 (단체 구성원(org role Owner·Admin·Member) 또는 이 team·상위 team의 Owner/Admin) — 기본은 team 직속만, 하위 team은 opt-in
 */
 spinoffOrgTeamsControllerListTeamMembers<TData = ListOrgMembersResponseDto>(orgId: string,
    teamId: string,
    params?: SpinoffOrgTeamsControllerListTeamMembersParams, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgTeamsControllerListTeamMembers<TData = ListOrgMembersResponseDto>(orgId: string,
    teamId: string,
    params?: SpinoffOrgTeamsControllerListTeamMembersParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgTeamsControllerListTeamMembers<TData = ListOrgMembersResponseDto>(orgId: string,
    teamId: string,
    params?: SpinoffOrgTeamsControllerListTeamMembersParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgTeamsControllerListTeamMembers<TData = ListOrgMembersResponseDto>(
    orgId: string,
    teamId: string,
    params?: SpinoffOrgTeamsControllerListTeamMembersParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/members`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/members`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/members`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * 새 사람(email 또는 phone, 둘 다 생략하면 연락처 없는 멤버 — Member 역할만)으로 이 팀의 자리를 만든다. 단체 직속 자리를 원본으로 복사하던 방식은 없다(팀 Admin·Owner가 단체 교직원일 필요가 없다). Member는 단체 Admin·Owner와 그 팀의 Admin·Owner가 만들 수 있고, Admin·Owner 자리는 단체 Admin·Owner와 그 팀의 Owner만 만들 수 있다. 허용되지 않으면 403이다.
 * @summary 팀 멤버 생성 (org admin 또는 이 팀의 Owner/Admin — 어떤 role을 만들 수 있는지는 권한 규칙으로 판정)
 */
 spinoffOrgTeamsControllerCreateTeamMember<TData = OrgMemberDto>(orgId: string,
    teamId: string,
    addTeamMemberBodyDto: AddTeamMemberBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgTeamsControllerCreateTeamMember<TData = OrgMemberDto>(orgId: string,
    teamId: string,
    addTeamMemberBodyDto: AddTeamMemberBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgTeamsControllerCreateTeamMember<TData = OrgMemberDto>(orgId: string,
    teamId: string,
    addTeamMemberBodyDto: AddTeamMemberBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgTeamsControllerCreateTeamMember<TData = OrgMemberDto>(
    orgId: string,
    teamId: string,
    addTeamMemberBodyDto: AddTeamMemberBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/teams/${teamId}/members`,
      addTeamMemberBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/teams/${teamId}/members`,
      addTeamMemberBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/teams/${teamId}/members`,
      addTeamMemberBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 이 팀의 Member 자리를 한 번에 만들고(create)·고치고(update)·지운다(delete). 팀은 URL로 고정되며 항목의 teamId(팀 이동)는 쓸 수 없다. Admin·Owner 자리를 만들거나 바꾸거나 지우는 항목은 400이다 — Admin·Owner 지정·해제는 단건 라우트로 한다(규칙 3·5). 다른 App이 만든 팀은 호출 앱 소유권으로 거부된다(403). schoolbell-e `POST :teamId/members/batch`와 같은 경로·모양이다(옛 이름 `mass-update`는 별칭으로 쓰지 않는다 — 새 라우트라 옛 호출자가 없다).
 * @summary 팀 멤버 일괄 변경 (org admin 또는 이 팀의 Owner/Admin) — Member 자리만
 */
 spinoffOrgTeamsControllerBatchWriteTeamMembers<TData = BatchOrgMembersResultDto>(orgId: string,
    teamId: string,
    batchTeamMembersBodyDto: BatchTeamMembersBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgTeamsControllerBatchWriteTeamMembers<TData = BatchOrgMembersResultDto>(orgId: string,
    teamId: string,
    batchTeamMembersBodyDto: BatchTeamMembersBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgTeamsControllerBatchWriteTeamMembers<TData = BatchOrgMembersResultDto>(orgId: string,
    teamId: string,
    batchTeamMembersBodyDto: BatchTeamMembersBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgTeamsControllerBatchWriteTeamMembers<TData = BatchOrgMembersResultDto>(
    orgId: string,
    teamId: string,
    batchTeamMembersBodyDto: BatchTeamMembersBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/teams/${teamId}/members/batch`,
      batchTeamMembersBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/teams/${teamId}/members/batch`,
      batchTeamMembersBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/teams/${teamId}/members/batch`,
      batchTeamMembersBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 대상이 이 팀 소속이 아니면 404. 지울 자리가 Member면 단체 Admin·Owner와 그 팀의 Admin·Owner가, Admin·Owner면 단체 Admin·Owner와 그 팀의 Owner만 지울 수 있다(규칙 3·5). 팀 자리에는 마지막 Owner 보호를 두지 않는다 — 단체 Admin·Owner가 언제든 복구할 수 있다.
 * @summary 팀 멤버 삭제 (org admin 또는 이 팀의 Owner/Admin — 어떤 role을 지울 수 있는지는 권한 규칙으로 판정)
 */
 spinoffOrgTeamsControllerDeleteTeamMember<TData = void>(orgId: string,
    teamId: string,
    memberId: string, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgTeamsControllerDeleteTeamMember<TData = void>(orgId: string,
    teamId: string,
    memberId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgTeamsControllerDeleteTeamMember<TData = void>(orgId: string,
    teamId: string,
    memberId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgTeamsControllerDeleteTeamMember<TData = void>(
    orgId: string,
    teamId: string,
    memberId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/teams/${teamId}/members/${memberId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/teams/${teamId}/members/${memberId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/orgs/${orgId}/teams/${teamId}/members/${memberId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * Member와 Admin·Owner 사이의 전환은 건드리는 자리(변경 전·후)마다 규칙을 만족해야 한다 — 예를 들어 팀 Admin은 Member를 Admin으로 올릴 수 없고(규칙 5는 팀 Owner만), 팀 Owner는 올릴 수 있다. 자기 자신 셀프 승격/강등도 같은 규칙을 따른다. 대상 멤버가 현재 이 teamId 소속이 아니면(다른 팀 소속이거나 팀 미배치) 404.
 * @summary 팀 멤버의 role을Owner/Admin/Member로 전환 (org admin 또는 이 팀의 Owner/Admin — 전환 가능 여부는 권한 규칙으로 판정)
 */
 spinoffOrgTeamsControllerUpdateTeamMemberRole<TData = OrgMemberDto>(orgId: string,
    teamId: string,
    memberId: string,
    updateTeamMemberRoleBodyDto: UpdateTeamMemberRoleBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgTeamsControllerUpdateTeamMemberRole<TData = OrgMemberDto>(orgId: string,
    teamId: string,
    memberId: string,
    updateTeamMemberRoleBodyDto: UpdateTeamMemberRoleBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgTeamsControllerUpdateTeamMemberRole<TData = OrgMemberDto>(orgId: string,
    teamId: string,
    memberId: string,
    updateTeamMemberRoleBodyDto: UpdateTeamMemberRoleBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgTeamsControllerUpdateTeamMemberRole<TData = OrgMemberDto>(
    orgId: string,
    teamId: string,
    memberId: string,
    updateTeamMemberRoleBodyDto: UpdateTeamMemberRoleBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/teams/${teamId}/members/${memberId}/role`,
      updateTeamMemberRoleBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/teams/${teamId}/members/${memberId}/role`,
      updateTeamMemberRoleBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/orgs/${orgId}/teams/${teamId}/members/${memberId}/role`,
      updateTeamMemberRoleBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * parentTeamId를 생략하거나 null이면 org 바로 밑(최상위)으로 옮긴다. previousSiblingId/nextSiblingId로 새 형제 사이 위치를 지정하고, 둘 다 없으면 맨 뒤에 붙는다(schoolbell-e와 같은 경로·body).
 * @summary 팀 이동(reparent) +형제 순서 변경 (org admin 전용) — 서브트리(자신+하위 team) 전체가 함께 이동한다
 */
 spinoffOrgTeamsControllerMoveTeam<TData = OrgTeamDto>(orgId: string,
    teamId: string,
    moveOrgTeamBodyDto: MoveOrgTeamBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 spinoffOrgTeamsControllerMoveTeam<TData = OrgTeamDto>(orgId: string,
    teamId: string,
    moveOrgTeamBodyDto: MoveOrgTeamBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 spinoffOrgTeamsControllerMoveTeam<TData = OrgTeamDto>(orgId: string,
    teamId: string,
    moveOrgTeamBodyDto: MoveOrgTeamBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  spinoffOrgTeamsControllerMoveTeam<TData = OrgTeamDto>(
    orgId: string,
    teamId: string,
    moveOrgTeamBodyDto: MoveOrgTeamBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/teams/${teamId}/position`,
      moveOrgTeamBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/teams/${teamId}/position`,
      moveOrgTeamBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/orgs/${orgId}/teams/${teamId}/position`,
      moveOrgTeamBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 컨텍스트 문자 템플릿 목록
 */
 orgTemplatesControllerList<TData = ListTemplatesResponseDto>(orgId: unknown, options?: HttpClientBodyOptions): Observable<TData>;
 orgTemplatesControllerList<TData = ListTemplatesResponseDto>(orgId: unknown, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgTemplatesControllerList<TData = ListTemplatesResponseDto>(orgId: unknown, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgTemplatesControllerList<TData = ListTemplatesResponseDto>(
    orgId: unknown, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/templates`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/templates`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/templates`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 컨텍스트 문자 템플릿 생성
 */
 orgTemplatesControllerCreate<TData = TemplateDto>(orgId: unknown,
    createTemplateBodyDto: CreateTemplateBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgTemplatesControllerCreate<TData = TemplateDto>(orgId: unknown,
    createTemplateBodyDto: CreateTemplateBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgTemplatesControllerCreate<TData = TemplateDto>(orgId: unknown,
    createTemplateBodyDto: CreateTemplateBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgTemplatesControllerCreate<TData = TemplateDto>(
    orgId: unknown,
    createTemplateBodyDto: CreateTemplateBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/templates`,
      createTemplateBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/templates`,
      createTemplateBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/templates`,
      createTemplateBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 소프트 삭제 (작성자 또는 org admin+ 만 가능)
 */
 orgTemplatesControllerRemove<TData = void>(orgId: unknown,
    id: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgTemplatesControllerRemove<TData = void>(orgId: unknown,
    id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgTemplatesControllerRemove<TData = void>(orgId: unknown,
    id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgTemplatesControllerRemove<TData = void>(
    orgId: unknown,
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/templates/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/orgs/${orgId}/templates/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/orgs/${orgId}/templates/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 단체 컨텍스트 문자 템플릿 수정 (본인 작성 템플릿만 가능)
 */
 orgTemplatesControllerUpdate<TData = TemplateDto>(orgId: unknown,
    id: string,
    updateTemplateBodyDto: UpdateTemplateBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 orgTemplatesControllerUpdate<TData = TemplateDto>(orgId: unknown,
    id: string,
    updateTemplateBodyDto: UpdateTemplateBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgTemplatesControllerUpdate<TData = TemplateDto>(orgId: unknown,
    id: string,
    updateTemplateBodyDto: UpdateTemplateBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgTemplatesControllerUpdate<TData = TemplateDto>(
    orgId: unknown,
    id: string,
    updateTemplateBodyDto: UpdateTemplateBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/templates/${id}`,
      updateTemplateBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/orgs/${orgId}/templates/${id}`,
      updateTemplateBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/orgs/${orgId}/templates/${id}`,
      updateTemplateBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 템플릿 복사 (공개 여부 무관, 조회 가능한 템플릿 누구나 가능)
 */
 orgTemplatesControllerCopy<TData = TemplateDto>(orgId: unknown,
    id: string, options?: HttpClientBodyOptions): Observable<TData>;
 orgTemplatesControllerCopy<TData = TemplateDto>(orgId: unknown,
    id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 orgTemplatesControllerCopy<TData = TemplateDto>(orgId: unknown,
    id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  orgTemplatesControllerCopy<TData = TemplateDto>(
    orgId: unknown,
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/orgs/${orgId}/templates/${id}/copy`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/orgs/${orgId}/templates/${id}/copy`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/orgs/${orgId}/templates/${id}/copy`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * isShared=true (default) 는 같은 tenant 모두 / isShared=false 는 본인만. deletedAt IS NULL. spinoff 자체 로그인 토큰 또는 schoolbell-e org-위임 compound token(`org.sms.send` 스코프) 수락.
 * @summary 내 tenant 의 발신번호 목록
 */
 originatorsControllerList<TData = ListOriginatorsResponseDto>(params?: OriginatorsControllerListParams, options?: HttpClientBodyOptions): Observable<TData>;
 originatorsControllerList<TData = ListOriginatorsResponseDto>(params?: OriginatorsControllerListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 originatorsControllerList<TData = ListOriginatorsResponseDto>(params?: OriginatorsControllerListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  originatorsControllerList<TData = ListOriginatorsResponseDto>(
    params?: OriginatorsControllerListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/originators`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/originators`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/originators`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * 발송사별 인증 흐름은 본 PR 범위 밖 — 등록 시점에는 항상 isVerified=false.
 * @summary 발신번호 등록 (isVerified=false)
 */
 originatorsControllerCreate<TData = OriginatorDto>(createOriginatorBodyDto: CreateOriginatorBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 originatorsControllerCreate<TData = OriginatorDto>(createOriginatorBodyDto: CreateOriginatorBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 originatorsControllerCreate<TData = OriginatorDto>(createOriginatorBodyDto: CreateOriginatorBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  originatorsControllerCreate<TData = OriginatorDto>(
    createOriginatorBodyDto: CreateOriginatorBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/originators`,
      createOriginatorBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/originators`,
      createOriginatorBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/originators`,
      createOriginatorBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * File 행을 미리 생성하고 GCS Signed PUT URL (15분 유효)을 반환한다. 클라이언트가 Content-Type 헤더를 포함해 GCS 에 직접 PUT 한 뒤, POST /originators 의 attachments 에 fileId 를 포함한다.
 * @summary 서류 업로드용 GCS Signed URL 발급
 */
 originatorsControllerGetUploadUrl<TData = UploadUrlResponseDto>(uploadUrlBodyDto: UploadUrlBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 originatorsControllerGetUploadUrl<TData = UploadUrlResponseDto>(uploadUrlBodyDto: UploadUrlBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 originatorsControllerGetUploadUrl<TData = UploadUrlResponseDto>(uploadUrlBodyDto: UploadUrlBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  originatorsControllerGetUploadUrl<TData = UploadUrlResponseDto>(
    uploadUrlBodyDto: UploadUrlBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/originators/documents/upload-url`,
      uploadUrlBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/originators/documents/upload-url`,
      uploadUrlBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/originators/documents/upload-url`,
      uploadUrlBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 조직 컨텍스트 토큰 필수. 등록 후 POST /originators 시 자동갈음 (BusinessRegistration 재업로드 불필요).
 * @summary 업로드 완료 후 단체 사업자등록증 File 등록 (D7)
 */
 originatorsControllerRegisterOrgDocument<TData = RegisterOrgDocumentResponseDto>(registerOrgDocumentBodyDto: RegisterOrgDocumentBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 originatorsControllerRegisterOrgDocument<TData = RegisterOrgDocumentResponseDto>(registerOrgDocumentBodyDto: RegisterOrgDocumentBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 originatorsControllerRegisterOrgDocument<TData = RegisterOrgDocumentResponseDto>(registerOrgDocumentBodyDto: RegisterOrgDocumentBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  originatorsControllerRegisterOrgDocument<TData = RegisterOrgDocumentResponseDto>(
    registerOrgDocumentBodyDto: RegisterOrgDocumentBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/originators/org-documents`,
      registerOrgDocumentBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/originators/org-documents`,
      registerOrgDocumentBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/originators/org-documents`,
      registerOrgDocumentBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 조직 컨텍스트 토큰 필수. sms-api 자체 GCS 버킷에 직접 PUT. 완료 후 POST /originators/org-documents 로 등록한다.
 * @summary 단체 사업자등록증 업로드용 GCS Signed URL 발급 (D7)
 */
 originatorsControllerGetOrgDocumentUploadUrl<TData = OrgDocumentUploadUrlResponseDto>(orgDocumentUploadUrlBodyDto: OrgDocumentUploadUrlBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 originatorsControllerGetOrgDocumentUploadUrl<TData = OrgDocumentUploadUrlResponseDto>(orgDocumentUploadUrlBodyDto: OrgDocumentUploadUrlBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 originatorsControllerGetOrgDocumentUploadUrl<TData = OrgDocumentUploadUrlResponseDto>(orgDocumentUploadUrlBodyDto: OrgDocumentUploadUrlBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  originatorsControllerGetOrgDocumentUploadUrl<TData = OrgDocumentUploadUrlResponseDto>(
    orgDocumentUploadUrlBodyDto: OrgDocumentUploadUrlBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/originators/org-documents/upload-url`,
      orgDocumentUploadUrlBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/originators/org-documents/upload-url`,
      orgDocumentUploadUrlBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/originators/org-documents/upload-url`,
      orgDocumentUploadUrlBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * BusinessRegistration(ownerRefKey 기준) / EmploymentCert(ownerRefKey+userId, 6개월 이내)만 반환. type 생략 시 두 유형 통합 반환. TelecomSubscription·IdCard 는 항상 빈 배열.
 * @summary 재사용 가능한 서류 파일 목록
 */
 originatorsControllerListReusableDocuments<TData = ReusableDocumentsResponseDto>(params?: OriginatorsControllerListReusableDocumentsParams, options?: HttpClientBodyOptions): Observable<TData>;
 originatorsControllerListReusableDocuments<TData = ReusableDocumentsResponseDto>(params?: OriginatorsControllerListReusableDocumentsParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 originatorsControllerListReusableDocuments<TData = ReusableDocumentsResponseDto>(params?: OriginatorsControllerListReusableDocumentsParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  originatorsControllerListReusableDocuments<TData = ReusableDocumentsResponseDto>(
    params?: OriginatorsControllerListReusableDocumentsParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/originators/reusable-documents`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/originators/reusable-documents`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/originators/reusable-documents`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 소프트 삭제 (deletedAt = now())
 */
 originatorsControllerRemove<TData = void>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 originatorsControllerRemove<TData = void>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 originatorsControllerRemove<TData = void>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  originatorsControllerRemove<TData = void>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/originators/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/originators/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/originators/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * spinoff 자체 로그인 토큰 또는 schoolbell-e org-위임 compound token(`org.sms.send` 스코프) 수락.
 * @summary 발신번호 단건
 */
 originatorsControllerGetById<TData = OriginatorDto>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 originatorsControllerGetById<TData = OriginatorDto>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 originatorsControllerGetById<TData = OriginatorDto>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  originatorsControllerGetById<TData = OriginatorDto>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/originators/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/originators/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/originators/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * isVerified 와 phoneNumber 는 PATCH 로 변경 불가.
 * @summary 발신번호 부분 수정 (shared/comment/lexorank)
 */
 originatorsControllerUpdate<TData = OriginatorDto>(id: string,
    updateOriginatorBodyDto: UpdateOriginatorBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 originatorsControllerUpdate<TData = OriginatorDto>(id: string,
    updateOriginatorBodyDto: UpdateOriginatorBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 originatorsControllerUpdate<TData = OriginatorDto>(id: string,
    updateOriginatorBodyDto: UpdateOriginatorBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  originatorsControllerUpdate<TData = OriginatorDto>(
    id: string,
    updateOriginatorBodyDto: UpdateOriginatorBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/originators/${id}`,
      updateOriginatorBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/originators/${id}`,
      updateOriginatorBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/originators/${id}`,
      updateOriginatorBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 발신번호에 첨부된 서류 목록 (본인 소유만)
 */
 originatorsControllerListDocuments<TData = ListOriginatorDocumentsResponseDto>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 originatorsControllerListDocuments<TData = ListOriginatorDocumentsResponseDto>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 originatorsControllerListDocuments<TData = ListOriginatorDocumentsResponseDto>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  originatorsControllerListDocuments<TData = ListOriginatorDocumentsResponseDto>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/originators/${id}/documents`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/originators/${id}/documents`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/originators/${id}/documents`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 민감 서류이므로 CDN 미경유. 본인 소유 발신번호의 파일만 접근 가능.
 * @summary 서류 파일 Signed GET URL 발급 (15분 유효)
 */
 originatorsControllerGetDocumentDownloadUrl<TData = OriginatorDocumentDownloadUrlDto>(id: string,
    fileId: string, options?: HttpClientBodyOptions): Observable<TData>;
 originatorsControllerGetDocumentDownloadUrl<TData = OriginatorDocumentDownloadUrlDto>(id: string,
    fileId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 originatorsControllerGetDocumentDownloadUrl<TData = OriginatorDocumentDownloadUrlDto>(id: string,
    fileId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  originatorsControllerGetDocumentDownloadUrl<TData = OriginatorDocumentDownloadUrlDto>(
    id: string,
    fileId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/originators/${id}/documents/${fileId}/download-url`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/originators/${id}/documents/${fileId}/download-url`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/originators/${id}/documents/${fileId}/download-url`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 이 조회도 `audit-log.read` 로 기록된다. 기록이 실패하면 결과도 주지 않는다.
 * @summary staff 접속기록 조회 (행위자·대상·단체 중 하나로 지정, cursor 내림차순 페이지)
 */
 staffAuditLogsControllerList<TData = StaffAuditLogsResponseDto>(params?: StaffAuditLogsControllerListParams, options?: HttpClientBodyOptions): Observable<TData>;
 staffAuditLogsControllerList<TData = StaffAuditLogsResponseDto>(params?: StaffAuditLogsControllerListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffAuditLogsControllerList<TData = StaffAuditLogsResponseDto>(params?: StaffAuditLogsControllerListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffAuditLogsControllerList<TData = StaffAuditLogsResponseDto>(
    params?: StaffAuditLogsControllerListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/audit-logs`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/audit-logs`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/staff/audit-logs`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * staff-web 진입 시 staffAuthGuard 가 호출 — 401 이면 refresh 로 세션 복원을 시도하고, 그래도 실패하면 authorize-redirect 로 navigate. `role`(학교종이 출입 역할)·`scopes`(지금 쓸 수 있는 RP scope)·`managementRole`·`canManageStaff` 는 메뉴·버튼 노출용이며 서버는 라우트마다 따로 거부한다. 이 호출이 본인 `Staff` 행을 만들거나 맞춘다.
 * @summary staff 세션 검증 + 사용자 정보와 유효 권한 반환
 */
 staffMeControllerMe<TData = StaffMeDto>( options?: HttpClientBodyOptions): Observable<TData>;
 staffMeControllerMe<TData = StaffMeDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffMeControllerMe<TData = StaffMeDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffMeControllerMe<TData = StaffMeDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/auth/me`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/auth/me`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/auth/me`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 초대 목록 (최신순, 상태 무관)
 */
 staffInvitationsControllerList<TData = StaffInvitationDto[]>( options?: HttpClientBodyOptions): Observable<TData>;
 staffInvitationsControllerList<TData = StaffInvitationDto[]>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffInvitationsControllerList<TData = StaffInvitationDto[]>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffInvitationsControllerList<TData = StaffInvitationDto[]>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/invitations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/invitations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/invitations`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 이미 수락된 번호는 409 `staff-already-member`, 대기 중이면 409 `invitation-pending`. Owner 역할은 400.
 * @summary staff 초대 — 번호로 초대 (Owner·Admin)
 */
 staffInvitationsControllerInvite<TData = StaffInvitationDto>(createStaffInvitationBodyDto: CreateStaffInvitationBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffInvitationsControllerInvite<TData = StaffInvitationDto>(createStaffInvitationBodyDto: CreateStaffInvitationBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffInvitationsControllerInvite<TData = StaffInvitationDto>(createStaffInvitationBodyDto: CreateStaffInvitationBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffInvitationsControllerInvite<TData = StaffInvitationDto>(
    createStaffInvitationBodyDto: CreateStaffInvitationBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/invitations`,
      createStaffInvitationBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/invitations`,
      createStaffInvitationBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/invitations`,
      createStaffInvitationBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 이미 처리된 초대는 409 `invitation-not-pending`.
 * @summary 대기 중인 초대 취소
 */
 staffInvitationsControllerCancel<TData = StaffInvitationDto>(invitationId: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffInvitationsControllerCancel<TData = StaffInvitationDto>(invitationId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffInvitationsControllerCancel<TData = StaffInvitationDto>(invitationId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffInvitationsControllerCancel<TData = StaffInvitationDto>(
    invitationId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/invitations/${invitationId}/cancel`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/invitations/${invitationId}/cancel`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/invitations/${invitationId}/cancel`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary staff 목록 — 관리 역할과 부여된 scope (staffId 오름차순 cursor 페이지)
 */
 staffMembersControllerList<TData = StaffMembersPageDto>(params?: StaffMembersControllerListParams, options?: HttpClientBodyOptions): Observable<TData>;
 staffMembersControllerList<TData = StaffMembersPageDto>(params?: StaffMembersControllerListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffMembersControllerList<TData = StaffMembersPageDto>(params?: StaffMembersControllerListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffMembersControllerList<TData = StaffMembersPageDto>(
    params?: StaffMembersControllerListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/members`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/members`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/staff/members`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 한 staff 의 관리 역할과 scope
 */
 staffMembersControllerGet<TData = StaffMemberDto>(staffId: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffMembersControllerGet<TData = StaffMemberDto>(staffId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffMembersControllerGet<TData = StaffMemberDto>(staffId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffMembersControllerGet<TData = StaffMemberDto>(
    staffId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/members/${staffId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/members/${staffId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/members/${staffId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * Owner 는 지정하지 못하고(400), 대상이 Owner 면 바꾸지 못하며(403 `owner-role-immutable`), 본인의 역할은 바꾸지 못한다(403 `self-role-change`).
 * @summary 관리 역할 변경 (Admin ↔ Member)
 */
 staffMembersControllerChangeRole<TData = StaffMemberRoleChangeDto>(staffId: string,
    putStaffMemberRoleBodyDto: PutStaffMemberRoleBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffMembersControllerChangeRole<TData = StaffMemberRoleChangeDto>(staffId: string,
    putStaffMemberRoleBodyDto: PutStaffMemberRoleBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffMembersControllerChangeRole<TData = StaffMemberRoleChangeDto>(staffId: string,
    putStaffMemberRoleBodyDto: PutStaffMemberRoleBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffMembersControllerChangeRole<TData = StaffMemberRoleChangeDto>(
    staffId: string,
    putStaffMemberRoleBodyDto: PutStaffMemberRoleBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/staff/members/${staffId}/role`,
      putStaffMemberRoleBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/staff/members/${staffId}/role`,
      putStaffMemberRoleBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/staff/members/${staffId}/role`,
      putStaffMemberRoleBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 한 scope 회수 (없으면 변경 없음 — 멱등)
 */
 staffMembersControllerRevokeScope<TData = StaffMemberScopeChangeDto>(staffId: string,
    scope: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffMembersControllerRevokeScope<TData = StaffMemberScopeChangeDto>(staffId: string,
    scope: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffMembersControllerRevokeScope<TData = StaffMemberScopeChangeDto>(staffId: string,
    scope: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffMembersControllerRevokeScope<TData = StaffMemberScopeChangeDto>(
    staffId: string,
    scope: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/staff/members/${staffId}/scopes/${scope}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/staff/members/${staffId}/scopes/${scope}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/staff/members/${staffId}/scopes/${scope}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 팩에 없는 scope 는 400 `unknown-scope`, fresh 가 아닌 scope 는 400 `not-grantable`. 본인에게도 줄 수 있다.
 * @summary 한 scope 부여 (이미 있으면 변경 없음 — 멱등)
 */
 staffMembersControllerAddScope<TData = StaffMemberScopeChangeDto>(staffId: string,
    scope: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffMembersControllerAddScope<TData = StaffMemberScopeChangeDto>(staffId: string,
    scope: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffMembersControllerAddScope<TData = StaffMemberScopeChangeDto>(staffId: string,
    scope: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffMembersControllerAddScope<TData = StaffMemberScopeChangeDto>(
    staffId: string,
    scope: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `/staff/members/${staffId}/scopes/${scope}`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `/staff/members/${staffId}/scopes/${scope}`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `/staff/members/${staffId}/scopes/${scope}`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 전 tenant 발송 이력 (cursor 내림차순 페이지)
 */
 staffMessagesControllerList<TData = StaffListMessagesResponseDto>(params?: StaffMessagesControllerListParams, options?: HttpClientBodyOptions): Observable<TData>;
 staffMessagesControllerList<TData = StaffListMessagesResponseDto>(params?: StaffMessagesControllerListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffMessagesControllerList<TData = StaffListMessagesResponseDto>(params?: StaffMessagesControllerListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffMessagesControllerList<TData = StaffListMessagesResponseDto>(
    params?: StaffMessagesControllerListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/messages`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/messages`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/staff/messages`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * 삭제된 파일(File.deletedAt IS NOT NULL)은 제외. position 순서대로 반환.
 * @summary MMS 첨부 파일 목록
 */
 staffMessagesControllerListAttachments<TData = StaffListMessageAttachmentsResponseDto>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffMessagesControllerListAttachments<TData = StaffListMessageAttachmentsResponseDto>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffMessagesControllerListAttachments<TData = StaffListMessageAttachmentsResponseDto>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffMessagesControllerListAttachments<TData = StaffListMessageAttachmentsResponseDto>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/messages/${id}/attachments`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/messages/${id}/attachments`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/messages/${id}/attachments`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 첨부 파일 Signed GET URL 발급 (15분 유효)
 */
 staffMessagesControllerGetAttachmentDownloadUrl<TData = StaffMessageAttachmentDownloadUrlDto>(id: string,
    fileId: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffMessagesControllerGetAttachmentDownloadUrl<TData = StaffMessageAttachmentDownloadUrlDto>(id: string,
    fileId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffMessagesControllerGetAttachmentDownloadUrl<TData = StaffMessageAttachmentDownloadUrlDto>(id: string,
    fileId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffMessagesControllerGetAttachmentDownloadUrl<TData = StaffMessageAttachmentDownloadUrlDto>(
    id: string,
    fileId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/messages/${id}/attachments/${fileId}/download-url`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/messages/${id}/attachments/${fileId}/download-url`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/messages/${id}/attachments/${fileId}/download-url`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 선사용·미연동 org 후보 검색 (이름/전화/이메일)
 */
 staffOrgProviderLinkControllerSearchUnlinked<TData = StaffUnlinkedOrgDto[]>(params: StaffOrgProviderLinkControllerSearchUnlinkedParams, options?: HttpClientBodyOptions): Observable<TData>;
 staffOrgProviderLinkControllerSearchUnlinked<TData = StaffUnlinkedOrgDto[]>(params: StaffOrgProviderLinkControllerSearchUnlinkedParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOrgProviderLinkControllerSearchUnlinked<TData = StaffUnlinkedOrgDto[]>(params: StaffOrgProviderLinkControllerSearchUnlinkedParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOrgProviderLinkControllerSearchUnlinked<TData = StaffUnlinkedOrgDto[]>(
    params: StaffOrgProviderLinkControllerSearchUnlinkedParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/orgs/unlinked`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/orgs/unlinked`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/staff/orgs/unlinked`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 선사용 org를 schoolbell-e providerOrgId에 수동 링크
 */
 staffOrgProviderLinkControllerLinkProvider<TData = StaffLinkedOrgDto>(id: string,
    staffLinkOrgProviderDto: StaffLinkOrgProviderDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffOrgProviderLinkControllerLinkProvider<TData = StaffLinkedOrgDto>(id: string,
    staffLinkOrgProviderDto: StaffLinkOrgProviderDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOrgProviderLinkControllerLinkProvider<TData = StaffLinkedOrgDto>(id: string,
    staffLinkOrgProviderDto: StaffLinkOrgProviderDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOrgProviderLinkControllerLinkProvider<TData = StaffLinkedOrgDto>(
    id: string,
    staffLinkOrgProviderDto: StaffLinkOrgProviderDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/orgs/${id}/link-provider`,
      staffLinkOrgProviderDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/orgs/${id}/link-provider`,
      staffLinkOrgProviderDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/orgs/${id}/link-provider`,
      staffLinkOrgProviderDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 새 연결 직후 자동으로 한 번 도는 대조를 다시 돌린다. `dryRun` 을 생략하면 보고만 하고, `false` 를 명시해야 대응되는 로컬 직속 자리를 학교종이 멤버를 가리키는 참조 자리로 바꾼다. 학교종이 명단을 읽지 못하면 아무것도 바꾸지 않고 `status: skipped` 로 이유를 돌려준다.
 * @summary 연결된 org 의 로컬 직속 자리 대조를 staff 가 다시 실행 (기본은 보고만)
 */
 staffSchoolbellOrgLinkControllerReconcileLinkSeats<TData = StaffReconcileLinkSeatsResultDto>(orgId: string,
    staffReconcileLinkSeatsDto: StaffReconcileLinkSeatsDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffSchoolbellOrgLinkControllerReconcileLinkSeats<TData = StaffReconcileLinkSeatsResultDto>(orgId: string,
    staffReconcileLinkSeatsDto: StaffReconcileLinkSeatsDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffSchoolbellOrgLinkControllerReconcileLinkSeats<TData = StaffReconcileLinkSeatsResultDto>(orgId: string,
    staffReconcileLinkSeatsDto: StaffReconcileLinkSeatsDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffSchoolbellOrgLinkControllerReconcileLinkSeats<TData = StaffReconcileLinkSeatsResultDto>(
    orgId: string,
    staffReconcileLinkSeatsDto: StaffReconcileLinkSeatsDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/orgs/${orgId}/reconcile-link-seats`,
      staffReconcileLinkSeatsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/orgs/${orgId}/reconcile-link-seats`,
      staffReconcileLinkSeatsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/orgs/${orgId}/reconcile-link-seats`,
      staffReconcileLinkSeatsDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 연결된 단체의 연동 해제 권한은 owner가 아니라 연결된 서비스(staff)에 있다. 해제 사유는 `StaffUnlinked`로 남고 그 연동의 SOT grant도 함께 정리한다. 연결이 없거나 이미 해제된 org는 변경 없이 204(멱등).
 * @summary 연결된 org의 provider 연동을 staff가 해제 (owner는 해제할 수 없다)
 */
 staffSchoolbellOrgLinkControllerUnlinkProvider<TData = void>(orgId: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffSchoolbellOrgLinkControllerUnlinkProvider<TData = void>(orgId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffSchoolbellOrgLinkControllerUnlinkProvider<TData = void>(orgId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffSchoolbellOrgLinkControllerUnlinkProvider<TData = void>(
    orgId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/orgs/${orgId}/unlink-provider`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/orgs/${orgId}/unlink-provider`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/orgs/${orgId}/unlink-provider`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 전 tenant 발신번호 목록 (cursor 페이지)
 */
 staffOriginatorsControllerList<TData = StaffListOriginatorsResponseDto>(params?: StaffOriginatorsControllerListParams, options?: HttpClientBodyOptions): Observable<TData>;
 staffOriginatorsControllerList<TData = StaffListOriginatorsResponseDto>(params?: StaffOriginatorsControllerListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOriginatorsControllerList<TData = StaffListOriginatorsResponseDto>(params?: StaffOriginatorsControllerListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOriginatorsControllerList<TData = StaffListOriginatorsResponseDto>(
    params?: StaffOriginatorsControllerListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/originators`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/originators`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/staff/originators`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 발신번호 승인 — isVerified=true, verifiedAt=now
 */
 staffOriginatorsControllerApprove<TData = StaffOriginatorDto>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffOriginatorsControllerApprove<TData = StaffOriginatorDto>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOriginatorsControllerApprove<TData = StaffOriginatorDto>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOriginatorsControllerApprove<TData = StaffOriginatorDto>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/staff/originators/${id}/approve`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/staff/originators/${id}/approve`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/staff/originators/${id}/approve`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 삭제된 파일(File.deletedAt IS NOT NULL) 은 제외. 운영팀 검토·승인·거절 판단용.
 * @summary 발신번호에 첨부된 서류 목록
 */
 staffOriginatorsControllerListDocuments<TData = StaffListDocumentsResponseDto>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffOriginatorsControllerListDocuments<TData = StaffListDocumentsResponseDto>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOriginatorsControllerListDocuments<TData = StaffListDocumentsResponseDto>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOriginatorsControllerListDocuments<TData = StaffListDocumentsResponseDto>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/originators/${id}/documents`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/originators/${id}/documents`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/originators/${id}/documents`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 신분증·재직증명서 등 민감 서류. CDN 캐싱 경로를 쓰지 않고 GCS Signed URL 을 직접 발급한다.
 * @summary 서류 파일 Signed GET URL 발급 (15분 유효)
 */
 staffOriginatorsControllerGetDocumentDownloadUrl<TData = StaffDocumentDownloadUrlDto>(id: string,
    fileId: string, options?: HttpClientBodyOptions): Observable<TData>;
 staffOriginatorsControllerGetDocumentDownloadUrl<TData = StaffDocumentDownloadUrlDto>(id: string,
    fileId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOriginatorsControllerGetDocumentDownloadUrl<TData = StaffDocumentDownloadUrlDto>(id: string,
    fileId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOriginatorsControllerGetDocumentDownloadUrl<TData = StaffDocumentDownloadUrlDto>(
    id: string,
    fileId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/originators/${id}/documents/${fileId}/download-url`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/originators/${id}/documents/${fileId}/download-url`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/originators/${id}/documents/${fileId}/download-url`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 발신번호 거절 — 거절 사유 저장 + 소프트 삭제 (deletedAt=now)
 */
 staffOriginatorsControllerReject<TData = void>(id: string,
    staffRejectOriginatorDto: StaffRejectOriginatorDto, options?: HttpClientBodyOptions): Observable<TData>;
 staffOriginatorsControllerReject<TData = void>(id: string,
    staffRejectOriginatorDto: StaffRejectOriginatorDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffOriginatorsControllerReject<TData = void>(id: string,
    staffRejectOriginatorDto: StaffRejectOriginatorDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffOriginatorsControllerReject<TData = void>(
    id: string,
    staffRejectOriginatorDto: StaffRejectOriginatorDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/staff/originators/${id}/reject`,
      staffRejectOriginatorDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/staff/originators/${id}/reject`,
      staffRejectOriginatorDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/staff/originators/${id}/reject`,
      staffRejectOriginatorDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 이 서비스의 scope북(역할별 scope 표)
 */
 staffMembersControllerScopeBook<TData = StaffScopeBookDto>( options?: HttpClientBodyOptions): Observable<TData>;
 staffMembersControllerScopeBook<TData = StaffScopeBookDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffMembersControllerScopeBook<TData = StaffScopeBookDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffMembersControllerScopeBook<TData = StaffScopeBookDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/scope-book`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/scope-book`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/staff/scope-book`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 문자 스토어(commerce) 대리 입장 매직링크 발급
 */
 staffSmsStoreControllerEnterToken<TData = SmsStoreEnterTokenResponseDto>( options?: HttpClientBodyOptions): Observable<TData>;
 staffSmsStoreControllerEnterToken<TData = SmsStoreEnterTokenResponseDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffSmsStoreControllerEnterToken<TData = SmsStoreEnterTokenResponseDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffSmsStoreControllerEnterToken<TData = SmsStoreEnterTokenResponseDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/staff/sms-store/enter-token`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/staff/sms-store/enter-token`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/staff/sms-store/enter-token`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 삭제 표시된 사용자도 포함한다. 조회 입력(번호)은 접속기록에 남지 않고 반환된 사용자 id 만 남는다.
 * @summary 휴대폰 번호로 사용자 찾기 (staff 열람, 접속기록 대상)
 */
 staffUsersControllerLookup<TData = StaffUserLookupResponseDto>(params: StaffUsersControllerLookupParams, options?: HttpClientBodyOptions): Observable<TData>;
 staffUsersControllerLookup<TData = StaffUserLookupResponseDto>(params: StaffUsersControllerLookupParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffUsersControllerLookup<TData = StaffUserLookupResponseDto>(params: StaffUsersControllerLookupParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffUsersControllerLookup<TData = StaffUserLookupResponseDto>(
    params: StaffUsersControllerLookupParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/users/lookup`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/users/lookup`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/staff/users/lookup`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * @summary 사용자별 투팩터 인증 이력 (cursor 내림차순 페이지, staff 열람, 접속기록 대상)
 */
 staffUsersControllerListChallenges<TData = StaffTwoFactorAuthChallengesResponseDto>(userId: string,
    params?: StaffUsersControllerListChallengesParams, options?: HttpClientBodyOptions): Observable<TData>;
 staffUsersControllerListChallenges<TData = StaffTwoFactorAuthChallengesResponseDto>(userId: string,
    params?: StaffUsersControllerListChallengesParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 staffUsersControllerListChallenges<TData = StaffTwoFactorAuthChallengesResponseDto>(userId: string,
    params?: StaffUsersControllerListChallengesParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  staffUsersControllerListChallenges<TData = StaffTwoFactorAuthChallengesResponseDto>(
    userId: string,
    params?: StaffUsersControllerListChallengesParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/staff/users/${userId}/two-factor-auth-challenges`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/staff/users/${userId}/two-factor-auth-challenges`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/staff/users/${userId}/two-factor-auth-challenges`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }

/**
 * 공용(isShared=true) 전체 + 본인 개인 템플릿. deletedAt IS NULL.
 * @summary 문자 템플릿 목록
 */
 templatesControllerList<TData = ListTemplatesResponseDto>( options?: HttpClientBodyOptions): Observable<TData>;
 templatesControllerList<TData = ListTemplatesResponseDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 templatesControllerList<TData = ListTemplatesResponseDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  templatesControllerList<TData = ListTemplatesResponseDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/templates`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/templates`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/templates`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 문자 템플릿 생성
 */
 templatesControllerCreate<TData = TemplateDto>(createTemplateBodyDto: CreateTemplateBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 templatesControllerCreate<TData = TemplateDto>(createTemplateBodyDto: CreateTemplateBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 templatesControllerCreate<TData = TemplateDto>(createTemplateBodyDto: CreateTemplateBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  templatesControllerCreate<TData = TemplateDto>(
    createTemplateBodyDto: CreateTemplateBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/templates`,
      createTemplateBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/templates`,
      createTemplateBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/templates`,
      createTemplateBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 소프트 삭제 (작성자 또는 org admin+ 만 가능)
 */
 templatesControllerRemove<TData = void>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 templatesControllerRemove<TData = void>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 templatesControllerRemove<TData = void>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  templatesControllerRemove<TData = void>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/templates/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/templates/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/templates/${id}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 문자 템플릿 수정 (본인 작성 템플릿만 가능)
 */
 templatesControllerUpdate<TData = TemplateDto>(id: string,
    updateTemplateBodyDto: UpdateTemplateBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 templatesControllerUpdate<TData = TemplateDto>(id: string,
    updateTemplateBodyDto: UpdateTemplateBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 templatesControllerUpdate<TData = TemplateDto>(id: string,
    updateTemplateBodyDto: UpdateTemplateBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  templatesControllerUpdate<TData = TemplateDto>(
    id: string,
    updateTemplateBodyDto: UpdateTemplateBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/templates/${id}`,
      updateTemplateBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/templates/${id}`,
      updateTemplateBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/templates/${id}`,
      updateTemplateBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 복사본은 항상 비공개("내 템플릿")로 생성된다.
 * @summary 템플릿 복사 (공개 여부 무관, 조회 가능한 템플릿 누구나 가능)
 */
 templatesControllerCopy<TData = TemplateDto>(id: string, options?: HttpClientBodyOptions): Observable<TData>;
 templatesControllerCopy<TData = TemplateDto>(id: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 templatesControllerCopy<TData = TemplateDto>(id: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  templatesControllerCopy<TData = TemplateDto>(
    id: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/templates/${id}/copy`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/templates/${id}/copy`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/templates/${id}/copy`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 투팩터 인증 시작 — 계정에 묶인 검증된 번호로 인증 코드를 보낸다. 번호는 요청으로 받지 않는다.
 */
 twoFactorAuthControllerCreateChallenge<TData = TwoFactorAuthChallengeResponseDto>(createTwoFactorAuthChallengeBodyDto: CreateTwoFactorAuthChallengeBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 twoFactorAuthControllerCreateChallenge<TData = TwoFactorAuthChallengeResponseDto>(createTwoFactorAuthChallengeBodyDto: CreateTwoFactorAuthChallengeBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 twoFactorAuthControllerCreateChallenge<TData = TwoFactorAuthChallengeResponseDto>(createTwoFactorAuthChallengeBodyDto: CreateTwoFactorAuthChallengeBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  twoFactorAuthControllerCreateChallenge<TData = TwoFactorAuthChallengeResponseDto>(
    createTwoFactorAuthChallengeBodyDto: CreateTwoFactorAuthChallengeBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/two-factor-auth/challenges`,
      createTwoFactorAuthChallengeBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/two-factor-auth/challenges`,
      createTwoFactorAuthChallengeBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/two-factor-auth/challenges`,
      createTwoFactorAuthChallengeBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 인증 코드 검증 — 성공하면 설정된 유효기간 동안 보호 API를 통과한다.
 */
 twoFactorAuthControllerVerifyChallenge<TData = TwoFactorAuthVerifyResponseDto>(challengeId: string,
    verifyTwoFactorAuthChallengeBodyDto: VerifyTwoFactorAuthChallengeBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 twoFactorAuthControllerVerifyChallenge<TData = TwoFactorAuthVerifyResponseDto>(challengeId: string,
    verifyTwoFactorAuthChallengeBodyDto: VerifyTwoFactorAuthChallengeBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 twoFactorAuthControllerVerifyChallenge<TData = TwoFactorAuthVerifyResponseDto>(challengeId: string,
    verifyTwoFactorAuthChallengeBodyDto: VerifyTwoFactorAuthChallengeBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  twoFactorAuthControllerVerifyChallenge<TData = TwoFactorAuthVerifyResponseDto>(
    challengeId: string,
    verifyTwoFactorAuthChallengeBodyDto: VerifyTwoFactorAuthChallengeBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/two-factor-auth/challenges/${challengeId}/verify`,
      verifyTwoFactorAuthChallengeBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/two-factor-auth/challenges/${challengeId}/verify`,
      verifyTwoFactorAuthChallengeBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/two-factor-auth/challenges/${challengeId}/verify`,
      verifyTwoFactorAuthChallengeBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary 현재 세션의 투팩터 인증 유효 여부. 보호 API를 호출하기 전에 미리 안내하려는 용도(선택).
 */
 twoFactorAuthControllerStatus<TData = TwoFactorAuthStatusResponseDto>( options?: HttpClientBodyOptions): Observable<TData>;
 twoFactorAuthControllerStatus<TData = TwoFactorAuthStatusResponseDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 twoFactorAuthControllerStatus<TData = TwoFactorAuthStatusResponseDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  twoFactorAuthControllerStatus<TData = TwoFactorAuthStatusResponseDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/two-factor-auth/status`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/two-factor-auth/status`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/two-factor-auth/status`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * order.confirmed 또는 order.payment_approved(Prepay 오퍼는 결제 승인이 곧 지급 신호) 수신 시 자체 org 매핑(JIT)으로 충전 대상을 판정하고 커머스 fill API를 호출해 크레딧을 즉시 확정 지급한다. order.refund_approved(스태프 승인 완료) 수신 시 동일하게 org를 매핑하고 커머스 reclaim API를 호출해 기지급 크레딧을 회수한다. order.refund_requested(승인 전 사실 통보)는 회수를 유발하지 않는다. 그 외 이벤트는 ACK만 반환.
 * @summary 커머스 주문 이벤트 수신 (order.confirmed/order.payment_approved/order.refund_approved 등)
 */
 commerceWebhookControllerReceive<TData = void>( options?: HttpClientBodyOptions): Observable<TData>;
 commerceWebhookControllerReceive<TData = void>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 commerceWebhookControllerReceive<TData = void>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  commerceWebhookControllerReceive<TData = void>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/webhooks/commerce`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/webhooks/commerce`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/webhooks/commerce`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 연동된 org를 찾아 OrgProviderConnection을 닫고, owner가 없으면 Org.deletedAt까지 하나의 트랜잭션으로 세팅한다(closeConnectionAndDissolveIfNeeded).
 * @summary schoolbell-e 이벤트 수신 (org.dissolved·user.contact-changed·staff.contact-changed, x-sbe-* HMAC)
 */
 schoolbellOrgDissolveControllerReceive<TData = void>( options?: HttpClientBodyOptions): Observable<TData>;
 schoolbellOrgDissolveControllerReceive<TData = void>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 schoolbellOrgDissolveControllerReceive<TData = void>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  schoolbellOrgDissolveControllerReceive<TData = void>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/webhooks/schoolbell-e`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/webhooks/schoolbell-e`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/webhooks/schoolbell-e`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 호출자가 넘긴 externalAuthCode를 schoolbell-e 표준 /oidc/token으로 교환해 refresh_token을 획득·저장하고, 로컬 Org 매핑이 없으면 함께 만든다(auto-org-link). 교환 실패 시 호출자(schoolbell-e-api)는 fail-open으로 해당 스코프만 드롭한다.
 * @summary schoolbell-e org grant 동기 확립 (x-sbe-* HMAC, schoolbell-e-api 전용)
 */
 schoolbellEOrgGrantEstablishControllerEstablish<TData = void>(establishOrgGrantBodyDto: EstablishOrgGrantBodyDto, options?: HttpClientBodyOptions): Observable<TData>;
 schoolbellEOrgGrantEstablishControllerEstablish<TData = void>(establishOrgGrantBodyDto: EstablishOrgGrantBodyDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 schoolbellEOrgGrantEstablishControllerEstablish<TData = void>(establishOrgGrantBodyDto: EstablishOrgGrantBodyDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  schoolbellEOrgGrantEstablishControllerEstablish<TData = void>(
    establishOrgGrantBodyDto: EstablishOrgGrantBodyDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/webhooks/schoolbell-e/org-grant`,
      establishOrgGrantBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/webhooks/schoolbell-e/org-grant`,
      establishOrgGrantBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/webhooks/schoolbell-e/org-grant`,
      establishOrgGrantBodyDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * 발송사가 등록한 콜백 URL. 어댑터가 인증·파싱하고 정규화된 이벤트를 DeliveryStatusService.applyDeliveryEvent 로 직접 반영.
 * @summary 발송사 delivery webhook 진입
 */
 smsWebhookControllerReceive<TData = void>(providerId: string, options?: HttpClientBodyOptions): Observable<TData>;
 smsWebhookControllerReceive<TData = void>(providerId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 smsWebhookControllerReceive<TData = void>(providerId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  smsWebhookControllerReceive<TData = void>(
    providerId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/webhooks/sms/${providerId}`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/webhooks/sms/${providerId}`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/webhooks/sms/${providerId}`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

};
